// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:31:03.375Z
// Property: The Bentley at Marietta (ID: 5745879600332800)
// Collections: 19 amenities, 3 floorplans (live), 24 photos, 82 POIs, 2 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5745879600332800",
  "property_external_id": "4665838",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/the-bentley-at-marietta-marietta-ga/r2s7130",
  "property_google_business_url": "https://www.google.com/maps/place/The+Bentley+at+Marietta/@33.9323101,-84.5523766,18z/data=!4m13!1m7!3m6!1s0x88f516907d2140bb:0x11d7c33fb5173795!2s880+S+Cobb+Dr+SE,+Marietta,+GA+30060!3b1!8m2!3d33.932579!4d-84.5518665!3m4!1s0x88f51690a8ca8cad:0xace9cc4ed8e49920!8m2!3d33.9322694!4d-84.5512422",
  "property_linkedin_url": "https://www.linkedin.com/in/george-bentley-7661b758",
  "property_hubspot_id": "8443923514",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-bentley-at-marietta",
  "property_name": "The Bentley at Marietta",
  "property_website_url": "https://www.thebentleyatmarietta.com/",
  "property_domain": "https://www.thebentleyatmarietta.com/",
  "property_address": "880 S Cobb Dr SE",
  "property_full_address": "880 S Cobb Dr SE, Marietta, GA 30060",
  "property_address_1": "880 S Cobb Dr SE",
  "property_address_2": null,
  "property_address_city": "Marietta",
  "property_address_state": "GA",
  "property_address_zip_full": "30060-3324",
  "property_address_zip": "30060",
  "property_address_country": "US",
  "property_address_county": "Cobb County",
  "property_neighborhood_address": "Fair Oaks",
  "property_address_latitude": "33.932579",
  "property_address_longitude": "-84.5518665",
  "property_email": "bentley@alapts.com",
  "property_phone": "(770) 427-2157",
  "property_call_tracking_phone": "470-327-8758",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Lakefront calm meets Marietta convenience.</strong> Explore spacious one- and two-bedroom apartments with renovated finishes, walk-in closets, and select sunrooms—then view <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Bentley at Marietta in person.</p>",
  "property_long_description": "<p><strong>Lakefront calm meets everyday Marietta convenience.</strong> At The Bentley at Marietta, you can choose a spacious one- or two-bedroom apartment in Fair Oaks with renovated finishes that feel polished without feeling fussy: granite countertops, stainless-steel appliances, decorative tile backsplashes, wood-style flooring, generous walk-in closets, washer and dryer connections, and sunrooms in select layouts.</p><p>Outside your door, a community lake, lakefront jogging trail, resort-style pool, 24-hour fitness center, grilling areas, fireside lounge, bark park, package lockers, and 24/7 online resident services make the community easy to enjoy from morning to night. Explore current <a href=\"/floor-plans\">one- and two-bedroom floor plans</a>, browse the <a href=\"/amenities\">amenities</a>, then look beyond the community to South Cobb Drive access, Fair Oaks Recreation Center, Marietta Square’s Glover Park, local dining, festivals, and the food-hall energy of Marietta Square Market—all part of the everyday rhythm of this connected Cobb County location.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-4589-7678-880f-2c187914aeea.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a teal sectional sofa, coffee table, and poufs.",
    "public_id": "019d02f3-4589-7678-880f-2c187914aeea",
    "storage_key": "property/5745879600332800/019d02f3-4589-7678-880f-2c187914aeea.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "222",
  "property_year_built": "1985",
  "property_year_renovated": "2020",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.8918918918919",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Application Fee $85\nAdministrative Fee $250\nNon-Refundable Pet Fee $370 / pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $499",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "375",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $375 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $375 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8187173.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://thebentleyatmarietta.loftliving.com/login",
  "property_apply_now_url": "https://8187173.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e7069-6aa6-7609-9b6e-42872f8866e0.webp",
  "property_primary_logo_media": {
    "alt_text": "The Bentley at Marietta Premier Apartments logo",
    "public_id": "019e7069-6aa6-7609-9b6e-42872f8866e0",
    "storage_key": "property/5745879600332800/019e7069-6aa6-7609-9b6e-42872f8866e0.webp",
    "width": 1266,
    "height": 493
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e7069-6b41-76d8-b347-37e0c36fd532.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Bentley at Marietta logo with text PREMIER APARTMENTS",
    "public_id": "019e7069-6b41-76d8-b347-37e0c36fd532",
    "storage_key": "property/5745879600332800/019e7069-6b41-76d8-b347-37e0c36fd532.webp",
    "width": 1266,
    "height": 493
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e7069-6a00-714f-abd5-9e3455508436.webp",
  "property_icon_media": {
    "alt_text": "The B logo",
    "public_id": "019e7069-6a00-714f-abd5-9e3455508436",
    "storage_key": "property/5745879600332800/019e7069-6a00-714f-abd5-9e3455508436.webp",
    "width": 845,
    "height": 845
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e7069-6a00-714f-abd5-9e3455508436.webp",
  "property_fav_icon_media": {
    "alt_text": "The B logo",
    "public_id": "019e7069-6a00-714f-abd5-9e3455508436",
    "storage_key": "property/5745879600332800/019e7069-6a00-714f-abd5-9e3455508436.webp",
    "width": 845,
    "height": 845
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f43b1-478f-7553-bbab-69edb1947e6b.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f43b1-478f-7553-bbab-69edb1947e6b",
    "storage_key": "property/5745879600332800/019f43b1-478f-7553-bbab-69edb1947e6b.webp",
    "width": 1266,
    "height": 493
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f43b1-3d51-7718-a5b0-079ae5ef2d94.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f43b1-3d51-7718-a5b0-079ae5ef2d94",
    "storage_key": "property/5745879600332800/019f43b1-3d51-7718-a5b0-079ae5ef2d94.webp",
    "width": 1266,
    "height": 493
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#6ea4dd",
  "property_secondary_color": "#175f9d",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#666666",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "800 - 1200",
  "property_sqft_min": "800",
  "property_sqft_max": "1200",
  "property_price_range": "1239 - 1974",
  "property_price_min": "1239",
  "property_price_max": "1974",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/TheBentleyatMarietta",
  "property_instagram_url": "https://www.instagram.com/thebentleyatmarietta",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJrYzKqJAW9YgRIJnk2E7M6aw",
  "property_youtube_url": "https://www.youtube.com/watch?v=x8PNQOLkc7Y",
  "property_yelp_url": "https://www.yelp.com/biz/the-bentley-at-marietta-marietta",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Polished amenities, everyday ease.</strong> At The Bentley at Marietta, lakefront jogging trails, a 24-hour fitness center, resort-style pool, fireside lounge, grilling areas, and a bark park create room to recharge your way. Package lockers, online resident services, and on-site management keep daily routines simple, while renovated interiors add granite countertops, stainless-steel appliances, wood-style flooring, walk-in closets, USB outlets, and select sunrooms.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find a floor plan with room to move.</strong> The Bentley at Marietta offers one- and two-bedroom layouts with smart storage, flexible living space, and select homes featuring granite countertops, stainless-steel appliances, tile backsplashes, wood-style flooring, walk-in closets, washer and dryer connections, and sunrooms. Compare available designs, then choose the space that fits the way each day unfolds.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at The Bentley at Marietta.</strong> Preview bright interiors with large windows, connected dining spaces, granite countertops, stainless-steel appliances, and light-filled sunrooms. Then look beyond the front door to lake views, the poolside lounge, fitness center, and outdoor gathering areas—all captured in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Fair Oaks keeps Marietta close.</strong> From The Bentley at Marietta, South Cobb Drive convenience, Chattahoochee Tech, KSU’s Marietta Campus, and CobbLinc Route 20 are all within easy reach. Spend time at Fair Oaks Park, explore Marietta Square’s restaurants, shops, Glover Park, and Marietta Square Market, then come home to a quieter lakefront setting that helps the day slow down.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews spotlight the everyday details.</strong> The Bentley at Marietta is often praised for clean, well-kept grounds, a welcoming office team, and prompt maintenance. Reviews also call out the quiet, peaceful setting, plus favorite spots like the pond and <a href=\"/amenities\">pool area</a>. Read more to see how residents describe life here in their own words.</p>",
  "property_neighborhood_blurb": "<p><strong>Fair Oaks puts Marietta within easy reach.</strong> From The Bentley at Marietta, your neighborhood map opens onto South Cobb Drive convenience, nearby Chattahoochee Tech and KSU’s Marietta Campus, and CobbLinc Route 20 connections toward Marietta and Cumberland. Keep weekends close with the fields, courts, and open-air space at Fair Oaks Park, or head a few minutes north for the downtown character of Marietta Square—Glover Park, local restaurants, patios, shops, and the food-hall buzz of Marietta Square Market. Back at home, a quieter lakefront setting gives you a welcome reset between errands, outings, and everyday plans. Want to see how the location feels in person? <a href=\"/schedule-a-tour\">Schedule a tour</a> and explore the area around you.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that add ease, polish, and room to unwind.</strong> At The Bentley at Marietta, your day can move from a workout in the 24-hour fitness center to a lap around the lakefront jogging trail, a swim at the resort-style pool, or an evening by the fireside lounge and grilling areas. Pet-friendly perks include a bark park, while package lockers, online resident services, on-site management, and the American Landmark 360 Resident Program help simplify the routine.</p><p>Inside, renovated apartment finishes bring the same thoughtful feel home with granite countertops, stainless-steel appliances, decorative tile backsplashes, wood-style flooring, USB outlets, generous walk-in closets, washer and dryer connections, and sunrooms in select layouts. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenity spaces up close.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Bentley at Marietta yours?</strong> Start your online application for a spacious one- or two-bedroom apartment with polished renovated finishes, from granite countertops and stainless-steel appliances to wood-style flooring and generous walk-in closets—all with lakefront calm and everyday Marietta convenience close at hand.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> The leasing team at The Bentley at Marietta is here to help you explore spacious one- and two-bedroom apartments, renovated finishes, and lakefront community living with everyday Marietta convenience. Reach out today—we’ll point you in the right direction.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Bentley at Marietta?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living— from spacious one- and two-bedroom layouts to resident services. If you don’t see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that gives your day room to flow.</strong> At The Bentley at Marietta, floor plans range from a comfortable one-bedroom apartment to two-bedroom designs with either one or two baths, so you can compare the space, storage, and privacy that work best for your routine. The Allatoona keeps things simple and efficient, while The Oconee and The Lanier add more room to spread out, host, work, or unwind.</p><p>Inside, select layouts pair everyday function with polished finishes, including sleek granite countertops, stainless-steel appliances, decorative tile backsplashes, wood-style flooring, generous walk-in closets, washer and dryer connections, and sunrooms available in some homes. Browse current availability, explore the <a href=\"/gallery\">photo gallery</a>, and <a href=\"/schedule-a-tour\">schedule a tour</a> when you find the floor plan that feels right.</p>",
  "property_gallery_blurb": "<p><strong>See the setting before you step inside.</strong> Browse photos of The Bentley at Marietta and picture the details that shape each day: bright living areas with large windows, connected dining spaces, kitchens with granite counters and stainless-steel appliances, and sunrooms that pull in an extra layer of light.</p><p>Outside, the gallery moves from calm lake views to the poolside lounge, fitness center, and outdoor gathering spots, giving you a feel for how the community looks from morning routines to relaxed evenings. Compare the spaces, linger over the finishes, then explore the full <a href=\"/amenities\">amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite views in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore what’s around The Bentley at Marietta.</strong> Use the interactive map to view available <a href=\"/floor-plans\">one- and two-bedroom apartments</a>, then see how lakefront calm, South Cobb Drive access, local dining, parks, and Marietta’s everyday energy connect from this Fair Oaks location.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, nap, and start the day with a tail wag.</strong> At The Bentley at Marietta, cats and dogs can feel right at home with space for up to two pets per apartment and no weight limit. Step outside for quick playtime at the bark park, stretch your route along the lakefront jogging trail, or settle into the slower pace of a community shaped by water views and outdoor gathering spaces.</p><p>Back inside, spacious one- and two-bedroom layouts, generous walk-in closets, and select sunrooms make it easier to keep pet gear organized and sunny spots claimed. Ready to picture the daily routine? Explore the <a href=\"/amenities\">pet-friendly amenities</a>, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the bark park and lakefront setting in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share the lakefront calm.</strong> Love the renovated finishes, spacious one- and two-bedroom layouts, and everyday ease at The Bentley at Marietta? Invite a friend to experience the community you already enjoy—then send your referral through the form below.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made easy.</strong><br>Log in anytime to pay rent, submit maintenance requests, and manage your account at The Bentley at Marietta—part of a lakefront community designed for everyday convenience, from package lockers to 24/7 online resident services.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents notice most.</strong> Reviews for The Bentley at Marietta often point to a community that feels well cared for, with clean grounds, a welcoming office team, and maintenance that responds promptly when something needs attention.</p><p>You’ll see residents call the property “quiet and peaceful,” praise the pond and pool area, and highlight how professional, understanding, and helpful the team can be throughout the leasing and living experience. Browse the reviews below to get a clearer sense of everyday life at The Bentley at Marietta—straight from the people who know it firsthand.</p>",
  "property_created_at": "1752256684877",
  "property_scheduletour_blurb": "<p><strong>See the lakefront calm for yourself.</strong> Tour The Bentley at Marietta and get a closer look at spacious one- and two-bedroom apartments with granite countertops, stainless-steel appliances, wood-style flooring, and generous walk-in closets—then picture everyday downtime by the community lake, jogging trail, and resort-style pool.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we received your inquiry.</strong><br>Our leasing team will follow up soon. In the meantime, picture lakefront calm, spacious one- and two-bedroom apartments, renovated finishes, and everyday Marietta convenience waiting at The Bentley at Marietta.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you arrive.</strong> Explore The Bentley at Marietta from wherever you are with virtual tours that bring each space into focus. Move through The Bentley apartment tour, compare the one-bedroom walkthrough with two-bedroom options in both one- and two-bath layouts, and look closer at details that are easier to understand in motion: open living and dining areas, bright windows, wood-style flooring, granite countertops, white cabinetry, stainless steel appliances, bedroom storage, and bath finishes. The community tour adds a broader feel for the setting, so you can connect the apartment interiors with the outdoor and shared spaces that shape the property. Start with the walkthroughs, then review <a href=\"/floor-plans\">current floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see it in person.</p>",
  "property_copyright": "2025 All Rights Reserved. The Bentley at Marietta",
  "property_seo_title_home": "Home | The Bentley at Marietta",
  "property_seo_description_home": "Welcome to The Bentley at Marietta! Stylish apartments, great amenities, and a vibrant community await. Discover your new home today!",
  "property_seo_title_floorplans": "Floor Plans | Marietta, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at The Bentley at Marietta! Browse our stylish one and two-bedroom floor plans that blend comfort and modern living in GA.",
  "property_seo_title_amenities": "Amenities | Marietta, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at The Bentley at Marietta! Enjoy a pool, fitness center, and more. Find your perfect one or two-bedroom home today!",
  "property_seo_title_gallery": "Gallery | Apartments in Marietta, GA",
  "property_seo_description_gallery": "Experience life at The Bentley at Marietta! From stunning amenities to spacious floor plans, picture your perfect home today and embrace your new lifestyle in GA.",
  "property_seo_title_virtualtours": "Virtual Tours | The Bentley at Marietta Apartments",
  "property_seo_description_virtualtours": "Step inside The Bentley at Marietta with our virtual tour! Choose from stylish one and two-bedroom floor plans in the heart of vibrant Marietta, GA.",
  "property_seo_title_interactivemap": "Interactive Map | The Bentley at Marietta Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Bentley in Marietta, GA! Use our interactive map to explore stylish 1 & 2-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Marietta, GA",
  "property_seo_description_neighborhood": "Immerse yourself in the vibrant Marietta community at The Bentley. Uncover local favorites, stunning parks, and dining gems just steps from your new home!",
  "property_seo_title_contact": "Contact Us | The Bentley at Marietta",
  "property_seo_description_contact": "Find your perfect home at The Bentley in Marietta, GA. Choose from spacious one- and two-bedroom floor plans. Have questions? Our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Marietta, GA",
  "property_seo_description_faqs": "Get the answers you need! Browse The Bentley at Marietta’s FAQs for insights on amenities, floor plans, and community life in beautiful Marietta, GA.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Marietta, GA",
  "property_seo_description_reviews": "Experience life at The Bentley in Marietta, GA! Check out resident reviews and see why our vibrant community, top-notch amenities, and welcoming atmosphere stand out.",
  "property_seo_title_applynow": "Apply Now | Apartments in Marietta, GA",
  "property_seo_description_applynow": "Experience modern living at The Bentley in Marietta, GA. With spacious layouts, resort-style amenities, and community events, your perfect home awaits!",
  "property_seo_title_residentaccess": "Resident Access | The Bentley at Marietta",
  "property_seo_description_residentaccess": "Log in to your Bentley at Marietta resident portal for easy rent payments, maintenance requests, and exclusive community updates. Your home, your control!",
  "property_seo_title_referafriend": "Refer A Friend | The Bentley at Marietta",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Bentley at Marietta and enjoy exclusive perks in our vibrant community. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Bentley at Marietta",
  "property_seo_description_scheduletour": "Experience luxurious living at The Bentley at Marietta. Schedule your tour today and step into your new home in the heart of Marietta, GA!",
  "property_seo_title_privacy": "Privacy Policy | The Bentley at Marietta",
  "property_seo_description_privacy": "Your privacy matters at The Bentley at Marietta. Uncover how we protect your data and enhance your living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Bentley at Marietta",
  "property_seo_description_accessibility": "At The Bentley at Marietta, we prioritize accessibility for all. Join our inclusive community where comfort meets convenience in beautiful Marietta, GA.",
  "property_seo_title_sitemap": "Sitemap | The Bentley at Marietta",
  "property_seo_description_sitemap": "Uncover your path at The Bentley at Marietta! Navigate our sitemap for a seamless journey through luxurious living, amenities, and community features.",
  "property_seo_title_thankyou": "Thank You | The Bentley at Marietta",
  "property_seo_description_thankyou": "Thank you for reaching out! A member of The Bentley at Marietta team will connect with you soon to help you find your perfect home in vibrant Marietta, GA!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651138653",
  "amenities": [
    {
      "id": "custom_f7bbed1c-0dd9-447f-91de-f3a2227e33a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3eb16bd2-7beb-48cb-aa20-90259afc9840",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Washer and Dryer Connections",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8dd15995-ab8f-47e0-9238-59ebccb5c410",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8805a820-0489-40a8-af60-bcbb41364987",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_20a6efd1-5904-4a1c-b71c-3b3f772b1f75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "Wall Outlets with USB Ports",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_37ec251d-2ae3-4af6-957a-3e1a3a474e2e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_97a4d836-869c-41c6-9e28-c1e1a0510f17",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000689",
      "title": "Sunroom",
      "amount": "0.0000",
      "description": "Sunrooms",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c1ebbfbc-585f-4954-b821-0eeb9ff3970a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_71ab313b-769a-41cb-abc2-8fab706eebce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool w/ Designer Lounges",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f1cfe8d2-c7ca-444f-b9b4-21697b1ca3b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd8e4fdf-a5b9-4dbd-b4d2-06e33bc7aa31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000634",
      "title": "Fire Pit",
      "amount": "0.0000",
      "description": "Community Fire Side Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b1e7efe-010d-4e89-9dd8-a29bc7a4b18c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_beed8233-c126-4bac-92ce-954edfb2ccb0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Community Grilling Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f2e97c79-05a9-46b9-939f-f22fdda80719",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000650",
      "title": "Jogging Trail",
      "amount": "0.0000",
      "description": "Lakefront Jogging Trail",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e575fa2-30c2-4a2e-9243-c76d3ea00221",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_316fd2fe-689f-418c-9057-7d1ac7118024",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000653",
      "title": "Lake",
      "amount": "0.0000",
      "description": "Private Community Lake",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0836ff6b-2ecf-4df9-bb3d-d862ef8693d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000668",
      "title": "Playground",
      "amount": "0.0000",
      "description": "Playground",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1397f416-3044-42cd-add1-ba0367ab05a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2bc55c77-fc76-4595-9128-0d556133345a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_c6c1a495-2622-414d-9e19-4110c247f80e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-94db-76bb-85ff-1b15a07aa1ad.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019e89c9-94db-76bb-85ff-1b15a07aa1ad",
        "storage_key": "property/5745879600332800/019e89c9-94db-76bb-85ff-1b15a07aa1ad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_217126b0-cdb5-49f2-ac31-6f5a774de816",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-92b6-774b-8de2-ddc543058a77.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a water fountain in front.",
        "public_id": "019e89c9-92b6-774b-8de2-ddc543058a77",
        "storage_key": "property/5745879600332800/019e89c9-92b6-774b-8de2-ddc543058a77.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautiful apartment buildings situated on the edge of a lake with a fountain, offering a serene living environment.",
      "link": "",
      "alt_text": "Apartment buildings with a water fountain in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c20b936-2f61-4590-88a2-f2f87d3877af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-8b7c-7168-b77d-14c3d2a00e7b.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and blue chairs, leading to a kitchen with stainless steel appliances.",
        "public_id": "019e89c9-8b7c-7168-b77d-14c3d2a00e7b",
        "storage_key": "property/5745879600332800/019e89c9-8b7c-7168-b77d-14c3d2a00e7b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a meal in your spacious dining area, complete with a stylish table and chairs, adjacent to a fully equipped kitchen featuring modern stainless steel appliances.",
      "link": "",
      "alt_text": "Dining area with a round table and blue chairs, leading to a kitchen with stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24b4806d-d368-404b-b346-5ec022763f10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-7cd6-7384-92a0-81182058c08e.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with agility equipment and benches at a multifamily property.",
        "public_id": "019e89c9-7cd6-7384-92a0-81182058c08e",
        "storage_key": "property/5745879600332800/019e89c9-7cd6-7384-92a0-81182058c08e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility equipment for your furry friends to play and exercise.",
      "link": "",
      "alt_text": "Fenced-in dog park with agility equipment and benches at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b6dd166-0cc7-482d-bffe-35a628d81d14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-7e4d-7678-aac6-680777a412aa.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a picnic table overlooking a lake and apartment buildings.",
        "public_id": "019e89c9-7e4d-7678-aac6-680777a412aa",
        "storage_key": "property/5745879600332800/019e89c9-7e4d-7678-aac6-680777a412aa.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and shaded seating areas. Enjoy the serene views of the adjacent lake, perfect for a tranquil escape.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a picnic table overlooking a lake and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ad9c1815-33d5-4631-bd41-1e7e1f832d02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-7c5a-735b-8b3b-6be675ae53ce.webp",
      "image_media": {
        "alt_text": "Charming bedroom with a king-size bed featuring navy and white patterned bedding and an orange throw blanket.",
        "public_id": "019e89c9-7c5a-735b-8b3b-6be675ae53ce",
        "storage_key": "property/5745879600332800/019e89c9-7c5a-735b-8b3b-6be675ae53ce.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This stylish bedroom offers a comfortable king-size bed with eye-catching navy and white patterned bedding, accented by a warm orange throw blanket and decorative wall art.",
      "link": "",
      "alt_text": "Charming bedroom with a king-size bed featuring navy and white patterned bedding and an orange throw blanket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c25f3542-81a0-4689-9175-e45639ddff8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-7c97-7294-a1c5-1993f7078fd8.webp",
      "image_media": {
        "alt_text": "Modern living room with a brown leather sofa, two navy armchairs, and a marble coffee table.",
        "public_id": "019e89c9-7c97-7294-a1c5-1993f7078fd8",
        "storage_key": "property/5745879600332800/019e89c9-7c97-7294-a1c5-1993f7078fd8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living area, featuring plush seating and elegant decor. Perfect for entertaining or enjoying a quiet evening.",
      "link": "",
      "alt_text": "Modern living room with a brown leather sofa, two navy armchairs, and a marble coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4a5b4bbe-f02d-4b10-b172-667b20c65816",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-7b52-742e-bf6d-5c37cf5d5eba.webp",
      "image_media": {
        "alt_text": "Spin bikes in a gym with mirrors and a TV screen.",
        "public_id": "019e89c9-7b52-742e-bf6d-5c37cf5d5eba",
        "storage_key": "property/5745879600332800/019e89c9-7b52-742e-bf6d-5c37cf5d5eba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with spin bikes and mirrored walls for your workout needs.",
      "link": "",
      "alt_text": "Spin bikes in a gym with mirrors and a TV screen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f229bc86-ae97-4bf2-9d66-c2bb461ff672",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-7c9c-774f-af8d-e699d7449e78.webp",
      "image_media": {
        "alt_text": "Outdoor fitness equipment by a pond with apartment buildings in the background.",
        "public_id": "019e89c9-7c9c-774f-af8d-e699d7449e78",
        "storage_key": "property/5745879600332800/019e89c9-7c9c-774f-af8d-e699d7449e78.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle with our outdoor fitness equipment, conveniently located beside the serene pond and apartment buildings.",
      "link": "",
      "alt_text": "Outdoor fitness equipment by a pond with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e1d57d38-bed8-47e0-be35-c1240c3da3e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-7a9c-768d-9eb4-a017eabadfe7.webp",
      "image_media": {
        "alt_text": "Living room with a blue sofa, patterned ottomans, coffee table, and a credenza.",
        "public_id": "019e89c9-7a9c-768d-9eb4-a017eabadfe7",
        "storage_key": "property/5745879600332800/019e89c9-7a9c-768d-9eb4-a017eabadfe7.webp",
        "width": 2909,
        "height": 1940
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable blue sofa, decorative ottomans, a coffee table with books, and a sleek credenza.",
      "link": "",
      "alt_text": "Living room with a blue sofa, patterned ottomans, coffee table, and a credenza.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62e84e66-d076-4565-b76c-756ac35cd0ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-7868-76fe-8377-7fc9b4def36c.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, overlooking a lake and apartment buildings.",
        "public_id": "019e89c9-7868-76fe-8377-7fc9b4def36c",
        "storage_key": "property/5745879600332800/019e89c9-7868-76fe-8377-7fc9b4def36c.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip or relax by the sparkling resort-style swimming pool. Soak up the sun on the comfortable lounge chairs or find shade under the umbrellas. This inviting pool area offers a perfect oasis for relaxation and fun, with picturesque views of the adjacent lake and modern apartment residences.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, overlooking a lake and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_636086db-d7c3-4fa0-b1bf-cbb7db9d0866",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-79b0-77ef-a2f0-a071b07bd3b5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and dark subway tile backsplash.",
        "public_id": "019e89c9-79b0-77ef-a2f0-a071b07bd3b5",
        "storage_key": "property/5745879600332800/019e89c9-79b0-77ef-a2f0-a071b07bd3b5.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautifully appointed kitchen featuring sleek white cabinetry, durable granite countertops, and modern stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and dark subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1605cf2d-13ca-4194-8272-95762d677f1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-72db-777c-86ce-92836826b7fa.webp",
      "image_media": {
        "alt_text": "Modern living room with teal sofa, coffee table, and ottoman. Kitchen area with bar stools visible in the background.",
        "public_id": "019e89c9-72db-777c-86ce-92836826b7fa",
        "storage_key": "property/5745879600332800/019e89c9-72db-777c-86ce-92836826b7fa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this stylish apartment's living area, featuring a plush teal sofa and a modern coffee table. The open-concept design includes a convenient kitchen area with bar seating.",
      "link": "",
      "alt_text": "Modern living room with teal sofa, coffee table, and ottoman. Kitchen area with bar stools visible in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e3cb1c6-e61e-4b76-b0df-b896f9365d23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-5e90-77ea-b986-1785fd318ac6.webp",
      "image_media": {
        "alt_text": "Amazon Hub package lockers",
        "public_id": "019e89c9-5e90-77ea-b986-1785fd318ac6",
        "storage_key": "property/5745879600332800/019e89c9-5e90-77ea-b986-1785fd318ac6.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Convenient package lockers for residents, providing secure and easy access to deliveries.",
      "link": "",
      "alt_text": "Amazon Hub package lockers",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7787f31-2101-4f56-b65f-804892dbe23b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-5e77-7068-a6ec-3a1c8a036e50.webp",
      "image_media": {
        "alt_text": "King-size bed with navy blue headboard and patterned bedding, nightstand with lamp and artwork above.",
        "public_id": "019e89c9-5e77-7068-a6ec-3a1c8a036e50",
        "storage_key": "property/5745879600332800/019e89c9-5e77-7068-a6ec-3a1c8a036e50.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Cozy king-size bedroom featuring a stylish navy blue headboard, plush patterned bedding, and a modern nightstand with a lamp. Includes a view into the en-suite bathroom.",
      "link": "",
      "alt_text": "King-size bed with navy blue headboard and patterned bedding, nightstand with lamp and artwork above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8278fb2e-6c85-4d3a-b4f2-d116e2f2fe10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-5eb7-73e9-8c02-cb15f9be727d.webp",
      "image_media": {
        "alt_text": "Home office with a desk, chair, and chaise lounge.",
        "public_id": "019e89c9-5eb7-73e9-8c02-cb15f9be727d",
        "storage_key": "property/5745879600332800/019e89c9-5eb7-73e9-8c02-cb15f9be727d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this apartment home, featuring a spacious desk and comfortable seating.",
      "link": "",
      "alt_text": "Home office with a desk, chair, and chaise lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0edf4021-6944-4139-8526-78b875a5d712",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-5d61-7349-9ce4-d1825dd50767.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed featuring a patterned comforter and an orange throw blanket.",
        "public_id": "019e89c9-5d61-7349-9ce4-d1825dd50767",
        "storage_key": "property/5745879600332800/019e89c9-5d61-7349-9ce4-d1825dd50767.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Apartment",
      "description": "Stylish bedroom with a large bed, decorative wall hangings, and an attached bathroom. Perfect for comfortable living.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed featuring a patterned comforter and an orange throw blanket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5e59b41e-2a43-4eee-8ab1-ab68b8089766",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-5d25-7022-9dfe-27af1310c47c.webp",
      "image_media": {
        "alt_text": "Modern living room with a teal sofa, abstract art, and two ottomans.",
        "public_id": "019e89c9-5d25-7022-9dfe-27af1310c47c",
        "storage_key": "property/5745879600332800/019e89c9-5d25-7022-9dfe-27af1310c47c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living room, featuring a comfortable teal sofa, modern decor, and ample natural light.",
      "link": "",
      "alt_text": "Modern living room with a teal sofa, abstract art, and two ottomans.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e82899f-023e-44de-829c-c2e11986d2e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-5ea6-73b9-9201-94179f8c1f80.webp",
      "image_media": {
        "alt_text": "Playground with slides and benches, with apartment buildings in the background.",
        "public_id": "019e89c9-5ea6-73b9-9201-94179f8c1f80",
        "storage_key": "property/5745879600332800/019e89c9-5ea6-73b9-9201-94179f8c1f80.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring slides and ample seating for relaxation.",
      "link": "",
      "alt_text": "Playground with slides and benches, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a9e040da-7b65-48dc-ba90-5fec7067b4a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-61ce-73fd-8a9b-840732809782.webp",
      "image_media": {
        "alt_text": "The Bentley at Marietta Premier Apartments monument sign and building entrance.",
        "public_id": "019e89c9-61ce-73fd-8a9b-840732809782",
        "storage_key": "property/5745879600332800/019e89c9-61ce-73fd-8a9b-840732809782.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Bentley at Marietta Premier Apartments. This image shows the monument sign and the building entrance of the property, with lush landscaping and a lake in the background.",
      "link": "",
      "alt_text": "The Bentley at Marietta Premier Apartments monument sign and building entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ca74e2d4-e5ad-4ffb-8380-6af9e9c2fe52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-5bf8-75c6-85c0-d43658e62fc7.webp",
      "image_media": {
        "alt_text": "Outdoor fitness equipment by a lake with apartment buildings in the background.",
        "public_id": "019e89c9-5bf8-75c6-85c0-d43658e62fc7",
        "storage_key": "property/5745879600332800/019e89c9-5bf8-75c6-85c0-d43658e62fc7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the fresh air and get a workout with our outdoor fitness equipment, located conveniently by the scenic lake and modern apartment buildings.",
      "link": "",
      "alt_text": "Outdoor fitness equipment by a lake with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa301a5a-30c4-4666-9746-6c40aef058bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-5c6c-718d-ae8a-a89c4e2ce197.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with chairs and tables on a wooden deck overlooking a lake and apartment buildings.",
        "public_id": "019e89c9-5c6c-718d-ae8a-a89c4e2ce197",
        "storage_key": "property/5745879600332800/019e89c9-5c6c-718d-ae8a-a89c4e2ce197.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the scenic views from our outdoor seating area, perfect for relaxing or socializing with friends. Overlooking a tranquil lake and our beautiful community buildings.",
      "link": "",
      "alt_text": "Outdoor seating area with chairs and tables on a wooden deck overlooking a lake and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d04c52fc-cf37-4583-a051-78df563b567e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-5d5b-760d-a6b0-ac39bc995173.webp",
      "image_media": {
        "alt_text": "Community coffee bar with sink, mini-fridge, and view of lake and apartments.",
        "public_id": "019e89c9-5d5b-760d-a6b0-ac39bc995173",
        "storage_key": "property/5745879600332800/019e89c9-5d5b-760d-a6b0-ac39bc995173.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks at our community coffee bar, complete with a double sink, mini-fridge, and a beautiful view of the lake and surrounding apartments.",
      "link": "",
      "alt_text": "Community coffee bar with sink, mini-fridge, and view of lake and apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c081a22b-4cfe-4d68-84a9-3020298948f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e89c9-454e-7328-a8d6-9099cc11c2a1.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and open closet reflected in the mirror.",
        "public_id": "019e89c9-454e-7328-a8d6-9099cc11c2a1",
        "storage_key": "property/5745879600332800/019e89c9-454e-7328-a8d6-9099cc11c2a1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-lit apartment bathroom featuring a spacious vanity with a sink and ample counter space, a modern toilet, and a glimpse into a walk-in closet.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, toilet, and open closet reflected in the mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_a6d457f4474d2520dae5a7ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "AZ Pizza, Wings & Fish (Halal)",
      "poi_type": "Restaurants",
      "poi_address": "855 S Cobb Dr SE, Marietta, GA 30060, USA",
      "poi_short_description": "Halal pizzeria turning out chicken on pizza, sandwiches and burgers, plus an outdoor seating area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-45c9-76dd-9930-573fa3a3a7c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-45c9-76dd-9930-573fa3a3a7c3",
        "storage_key": "property/5745879600332800/019f14f7-45c9-76dd-9930-573fa3a3a7c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://azpizzaga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2220218675656792142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "az-pizza-wings--fish-halal",
      "poi_latitude": "33.9318143",
      "poi_longitude": "-84.5485865",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 470-689-3179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlzwmoZMX9YgRThg2Th_Nzx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_bff135700fa6892430998c62",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "The Bowl",
      "poi_type": "Restaurants",
      "poi_address": "369 Cobb Pkwy SE, Marietta, GA 30060, USA",
      "poi_short_description": "Informal eatery dishing up a broad range of Asian cuisines in a low-key, contemporary space.",
      "poi_long_description": "Informal eatery dishing up a broad range of Asian cuisines in a low-key, contemporary space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-47a5-7008-96a1-2733c476452c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-47a5-7008-96a1-2733c476452c",
        "storage_key": "property/5745879600332800/019f14f7-47a5-7008-96a1-2733c476452c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1256023959065967530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bowl",
      "poi_latitude": "33.9432142",
      "poi_longitude": "-84.51593249999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-702-1129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe6k-7P0T9YgRqruB1SJLbhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4b83348c5a4486c422b92646",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Marietta Diner",
      "poi_type": "Restaurants",
      "poi_address": "306 Cobb Pkwy SE, Marietta, GA 30060, USA",
      "poi_short_description": "Classic neon-fronted diner open 24/7, with huge menu including Greek specialties & big breakfasts.",
      "poi_long_description": "Classic neon-fronted diner open 24/7, with huge menu including Greek specialties & big breakfasts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f4-b7c0-71be-b969-9957c533c473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-b7c0-71be-b969-9957c533c473",
        "storage_key": "property/5745879600332800/019f14f4-b7c0-71be-b969-9957c533c473.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mariettadiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5164610195861905949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marietta-diner",
      "poi_latitude": "33.944652",
      "poi_longitude": "-84.5176647",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-423-9390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0HHZv4T9YgRHaK1H5xhrEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_b0fe922dddd7ed290945445f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Gianni & Mac's Ristorante",
      "poi_type": "Restaurants",
      "poi_address": "85 Church St, Marietta, GA 30060, USA",
      "poi_short_description": "Informal joint with a menu of pizzas, pastas and cocktails, as well as a bar and a patio.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-4eb8-77f9-b41d-314e13b45f11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-4eb8-77f9-b41d-314e13b45f11",
        "storage_key": "property/5745879600332800/019f14f7-4eb8-77f9-b41d-314e13b45f11.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.gianniandmacs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10905195449208857363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gianni--macs-ristorante",
      "poi_latitude": "33.953757",
      "poi_longitude": "-84.55051550000002",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-746-3144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG7xb8SgV9YgRE-NMnHsJV5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_8406fd8abde760ec04977b69",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Marietta Proper",
      "poi_type": "Restaurants",
      "poi_address": "9 W Park Square, Marietta, GA 30060, USA",
      "poi_short_description": "Upscale bistro featuring a menu of globally inspired small plates, an extensive wine list and cocktails, plus brunch.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-4eba-7530-a35d-797493bd1c53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-4eba-7530-a35d-797493bd1c53",
        "storage_key": "property/5745879600332800/019f14f7-4eba-7530-a35d-797493bd1c53.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mariettaproper.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17983444083702033029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marietta-proper",
      "poi_latitude": "33.9523669",
      "poi_longitude": "-84.55048459999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-744-2882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-195d-74bd-990e-b8cedef628a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-195d-74bd-990e-b8cedef628a1",
        "storage_key": "property/5745879600332800/019f14f8-195d-74bd-990e-b8cedef628a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXUjrHEV9YgRheooHx0Hkvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "ec_6d4bfd1874738342f799ebaa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Taqueria Tsunami",
      "poi_type": "Restaurants",
      "poi_address": "70 S Park Square NE, Marietta, GA 30060, USA",
      "poi_short_description": "Local Latin-Asian fusion chain serving tacos, quesadillas & bowls in a relaxed, stylish space.",
      "poi_long_description": "Local Latin-Asian fusion chain serving tacos, quesadillas & bowls in a relaxed, stylish space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-4b22-75d9-b639-b956fb0490db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-4b22-75d9-b639-b956fb0490db",
        "storage_key": "property/5745879600332800/019f14f7-4b22-75d9-b639-b956fb0490db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.taqueriatsunami.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15134017634239706515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-tsunami",
      "poi_latitude": "33.9520968",
      "poi_longitude": "-84.54975999999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-324-7491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZwsn9SQU9YgRk_Va2drUBtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_62d4a99f269734271c6d85de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Mac's Chop House",
      "poi_type": "Restaurants",
      "poi_address": "19 N Park Square, Marietta, GA 30060, USA",
      "poi_short_description": "Dimly lit steakhouse with a classy, old-school vibe, offering meat dishes, cocktails & bourbon.",
      "poi_long_description": "Dimly lit steakhouse with a classy, old-school vibe, offering meat dishes, cocktails & bourbon.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-461b-706f-a538-075e9e753675.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-461b-706f-a538-075e9e753675",
        "storage_key": "property/5745879600332800/019f14f7-461b-706f-a538-075e9e753675.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://macschophouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1924926756530696226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macs-chop-house",
      "poi_latitude": "33.9533601",
      "poi_longitude": "-84.55009299999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-238-1202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr1DZvPIV9YgRIjCota-2tho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_65fee3dbb9a9ecbe19a9fe3d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Spring Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "36 Mill St, Marietta, GA 30060, USA",
      "poi_short_description": "New American restaurant serving seasonal, thoughtfully sourced dishes, as well as natural wines.",
      "poi_long_description": "New American restaurant serving seasonal, thoughtfully sourced dishes, as well as natural wines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-4f69-77df-b0ae-6cb50733e22f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-4f69-77df-b0ae-6cb50733e22f",
        "storage_key": "property/5745879600332800/019f14f7-4f69-77df-b0ae-6cb50733e22f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://springmarietta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15830886306127972929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-restaurant",
      "poi_latitude": "33.9536258",
      "poi_longitude": "-84.5509368",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-540-2777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF4nE3yQU9YgRQYpaRDibsts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_d89952100803e08149a7948d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "La Parrilla Mexican Restaurant - Marietta Square, GA",
      "poi_type": "Restaurants",
      "poi_address": "29 South Marietta Pkwy SW, Marietta, GA 30060, USA",
      "poi_short_description": "Colorful, family-friendly chain serving a variety of Mexican dishes & margaritas.",
      "poi_long_description": "Colorful, family-friendly chain serving a variety of Mexican dishes & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-47b9-74bc-ba77-9bf683c49b2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-47b9-74bc-ba77-9bf683c49b2b",
        "storage_key": "property/5745879600332800/019f14f7-47b9-74bc-ba77-9bf683c49b2b.webp",
        "width": 1280,
        "height": 529
      },
      "poi_business_url": "https://www.laparrilla.com/locations/marietta-square-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=11993506248697900211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-parrilla-mexican-restaurant---marietta-square-ga",
      "poi_latitude": "33.9514013",
      "poi_longitude": "-84.5514242",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-427-0055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3-aasSUU9YgRs-wQjWN-caY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_0a6ce49d00e137f041b378f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Marietta Pizza Co",
      "poi_type": "Restaurants",
      "poi_address": "3 Whitlock Ave SW, Marietta, GA 30064, USA",
      "poi_short_description": "Lots of pie styles, salads, subs & wings pair with tap beer in a funky parlor with local art & TVs.",
      "poi_long_description": "Lots of pie styles, salads, subs & wings pair with tap beer in a funky parlor with local art & TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-480e-767f-a329-defd31cf7691.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-480e-767f-a329-defd31cf7691",
        "storage_key": "property/5745879600332800/019f14f7-480e-767f-a329-defd31cf7691.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mariettapizza.com/square/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=17975278223322404733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marietta-pizza-co",
      "poi_latitude": "33.952105",
      "poi_longitude": "-84.550415",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-419-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8qLdSUU9YgRfVfyl04Edfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_c0c8a98a979b7e5863f715df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Tuesday Coffee + Shoppe",
      "poi_type": "Restaurants",
      "poi_address": "137 Church St, Marietta, GA 30060, USA",
      "poi_short_description": "Casual, cozy, quaint eatery serving up drip coffee and lattes, plus homemade pastries and gifts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-522b-7704-98e4-df048e68f9ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-522b-7704-98e4-df048e68f9ca",
        "storage_key": "property/5745879600332800/019f14f7-522b-7704-98e4-df048e68f9ca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://tuesdaysinmarietta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3472294196385662659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tuesday-coffee--shoppe",
      "poi_latitude": "33.9549721",
      "poi_longitude": "-84.55045899999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-1961-7268-ba96-5b76a4636003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-1961-7268-ba96-5b76a4636003",
        "storage_key": "property/5745879600332800/019f14f8-1961-7268-ba96-5b76a4636003.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJYbm1Y8AV9YgRw8Y3sywRMDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_8d0d2d474ebf6055c1db07e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Sessions Stand",
      "poi_type": "Restaurants",
      "poi_address": "397 Sessions St NW #200, Marietta, GA 30060, USA",
      "poi_short_description": "Walk-up coffee purveyor for lattes and espresso drinks with housemade pastries on the menu.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-569d-7317-91be-1b58c7b0aff9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-569d-7317-91be-1b58c7b0aff9",
        "storage_key": "property/5745879600332800/019f14f7-569d-7317-91be-1b58c7b0aff9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sessions-stand.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18110273356490050119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sessions-stand",
      "poi_latitude": "33.9614843",
      "poi_longitude": "-84.5529169",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-1961-7268-ba96-5b76a4636003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-1961-7268-ba96-5b76a4636003",
        "storage_key": "property/5745879600332800/019f14f8-1961-7268-ba96-5b76a4636003.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJLSW7kjkU9YgRR4rPVqqdVPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_eba50d1ea7f0096b602d73ca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Hamp & Harry's",
      "poi_type": "Restaurants",
      "poi_address": "168 Roswell St NE, Marietta, GA 30060, USA",
      "poi_short_description": "Upscale tavern at the square known for creative cocktails and small plates such as dumplings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-6367-709c-8288-8ca21b9687b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-6367-709c-8288-8ca21b9687b4",
        "storage_key": "property/5745879600332800/019f14f7-6367-709c-8288-8ca21b9687b4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.hampandharrys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4618261112399948045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hamp--harrys",
      "poi_latitude": "33.9521262",
      "poi_longitude": "-84.5483126",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-872-0977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTTrP41wV9YgRDWmZXANcF0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_99898d5704f6af512a3e695a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Marietta Fish Market",
      "poi_type": "Restaurants",
      "poi_address": "3185 Canton Rd, Marietta, GA 30066, USA",
      "poi_short_description": "Large family restaurant serving ample portions of seafood dishes in a dramatic ocean-themed setting.",
      "poi_long_description": "Large family restaurant serving ample portions of seafood dishes in a dramatic ocean-themed setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-524a-75ee-adc3-7769f402a61a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-524a-75ee-adc3-7769f402a61a",
        "storage_key": "property/5745879600332800/019f14f7-524a-75ee-adc3-7769f402a61a.webp",
        "width": 800,
        "height": 380
      },
      "poi_business_url": "http://www.mariettafishmarket.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17070068529391125231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marietta-fish-market",
      "poi_latitude": "34.0295689",
      "poi_longitude": "-84.52838419999999",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 770-218-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3yu-hawU9YgR78Lu6eIQ5ew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_8cc04032b46a41caa85a2f32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "The Marietta Local",
      "poi_type": "Restaurants",
      "poi_address": "148 Roswell St NE, Marietta, GA 30060, USA",
      "poi_short_description": "Rustic-chic counter serve featuring American breakfast & lunch fare such as omelets & meatloaf.",
      "poi_long_description": "Rustic-chic counter serve featuring American breakfast & lunch fare such as omelets & meatloaf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-5680-748a-a4ce-21b5fa2339b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-5680-748a-a4ce-21b5fa2339b3",
        "storage_key": "property/5745879600332800/019f14f7-5680-748a-a4ce-21b5fa2339b3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.themariettalocal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=513960354125916280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-marietta-local",
      "poi_latitude": "33.9520084",
      "poi_longitude": "-84.54883219999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-766-8403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-920304e8d5d1",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-920304e8d5d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_sogSQU9YgReChPEDj0IQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_fd1db2881acec957f1a31213",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Cobb Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "U.S. 41, 1405 Cobb Pkwy SE Unit A, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-58c1-737e-a96d-9f940b3033cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-58c1-737e-a96d-9f940b3033cf",
        "storage_key": "property/5745879600332800/019f14f7-58c1-737e-a96d-9f940b3033cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4325790016230550380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cobb-food-mart",
      "poi_latitude": "33.9180381",
      "poi_longitude": "-84.5007851",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-428-2070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-19d5-7298-b215-ca62ba4ea42b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-19d5-7298-b215-ca62ba4ea42b",
        "storage_key": "property/5745879600332800/019f14f8-19d5-7298-b215-ca62ba4ea42b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJs4EfZRUR9YgRbGtayhlLCDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_14f32ee8e1798f35d740a039",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "249 Cobb Pkwy SE, Marietta, GA 30060, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-5df5-74dc-a851-6f7878cb001a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-5df5-74dc-a851-6f7878cb001a",
        "storage_key": "property/5745879600332800/019f14f7-5df5-74dc-a851-6f7878cb001a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/marietta/249-cobb-parkway-se/l979",
      "poi_directions_map_url": "https://maps.google.com/?cid=1661418747741567990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.94582",
      "poi_longitude": "-84.51744",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9c-7099-a2d3-42de2e3ec046.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9c-7099-a2d3-42de2e3ec046",
        "storage_key": "property/5745879600332800/019d02f3-bd9c-7099-a2d3-42de2e3ec046.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVdtvVcT9YgR9ntPaoyLDhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_99f11f05dd28d1096eb8b790",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "K & Y Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1815 S Cobb Dr SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-5a05-72fa-9cf5-531686654990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-5a05-72fa-9cf5-531686654990",
        "storage_key": "property/5745879600332800/019f14f7-5a05-72fa-9cf5-531686654990.webp",
        "width": 960,
        "height": 536
      },
      "poi_business_url": "http://www.knypharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7726330457095112782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "k--y-pharmacy",
      "poi_latitude": "33.9087541",
      "poi_longitude": "-84.54342319999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-989-1332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-1970-7053-be17-4f9d8aae1c23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-1970-7053-be17-4f9d8aae1c23",
        "storage_key": "property/5745879600332800/019f14f8-1970-7053-be17-4f9d8aae1c23.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Ve3pysX9YgRTohvaJ1wOWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_025b787726c72aed8c6344da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Sunoco",
      "poi_type": "Shopping & Retail",
      "poi_address": "1414 S Cobb Dr SE, Marietta, GA 30008, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-61be-7019-bb8e-23276e6a0b25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-61be-7019-bb8e-23276e6a0b25",
        "storage_key": "property/5745879600332800/019f14f7-61be-7019-bb8e-23276e6a0b25.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.sunoco.com/locations/store/1414-s-cobb-dr-marietta-ga-0881680300",
      "poi_directions_map_url": "https://maps.google.com/?cid=13026651831589454671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunoco",
      "poi_latitude": "33.9182683",
      "poi_longitude": "-84.5495143",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-421-1635",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-1965-778e-813c-721f5eb7d801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-1965-778e-813c-721f5eb7d801",
        "storage_key": "property/5745879600332800/019f14f8-1965-778e-813c-721f5eb7d801.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_fyZuwW9YgRT8OUmtL2x7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_18d2b3b67471b52ff20d14cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1785 Cobb Pkwy SE, Marietta, GA 30060, USA",
      "poi_short_description": "Electronics retailer featuring groceries, sporting goods and apparel items, plus bakery goods, home goods, furniture and toys.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-6d86-73cc-81f9-ff90fec58a63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-6d86-73cc-81f9-ff90fec58a63",
        "storage_key": "property/5745879600332800/019f14f7-6d86-73cc-81f9-ff90fec58a63.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.walmart.com/store/1181-marietta-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3743842124350121479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.909961",
      "poi_longitude": "-84.4886219",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-955-0626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-9564d4de41f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-9564d4de41f3",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-9564d4de41f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6XB-ZRAR9YgRB2YIjZPM9DM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_ad7159fe29532e7989a88a9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "150 Cobb Pkwy SE, Marietta, GA 30060, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-6a69-7345-9bfe-0c7a1836be77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-6a69-7345-9bfe-0c7a1836be77",
        "storage_key": "property/5745879600332800/019f14f7-6a69-7345-9bfe-0c7a1836be77.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/8203-marietta-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=4893092533916609950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "33.9486626",
      "poi_longitude": "-84.5215291",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-423-7018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-9564d4de41f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-9564d4de41f3",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-9564d4de41f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ449iuvgT9YgRni03IbzB50M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_694a55695b703380e0aaf5aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "180 Cobb Pkwy SE Ste 210, Marietta, GA 30060, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-68da-701e-ad60-d7a5e7a04f47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-68da-701e-ad60-d7a5e7a04f47",
        "storage_key": "property/5745879600332800/019f14f7-68da-701e-ad60-d7a5e7a04f47.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/ga/marietta/180-cobb-parkway-south-ste-210?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12739325752954210486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "33.9473511",
      "poi_longitude": "-84.52313749999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 470-531-0489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-9564d4de41f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-9564d4de41f3",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-9564d4de41f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfz1nmAAU9YgRtkjSxkYty7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_8779cccabcdaf97142c9aa1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Big A Bottle Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "957 South Marietta Pkwy SE, Marietta, GA 30060, USA",
      "poi_short_description": "Basic merchant popular with locals for discounted spirits, basic bar needs & beers by request.",
      "poi_long_description": "Basic merchant popular with locals for discounted spirits, basic bar needs & beers by request.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-71d4-77a3-be9d-6f76282b30d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-71d4-77a3-be9d-6f76282b30d4",
        "storage_key": "property/5745879600332800/019f14f7-71d4-77a3-be9d-6f76282b30d4.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.facebook.com/bigabottleshop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6893164917770758444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-a-bottle-shop",
      "poi_latitude": "33.9414118",
      "poi_longitude": "-84.5247921",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-427-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9d-759c-90b9-9564d4de41f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9d-759c-90b9-9564d4de41f3",
        "storage_key": "property/5745879600332800/019d02f3-bd9d-759c-90b9-9564d4de41f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOyFIv6oW9YgRLCnpnfhwqV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "ec_351a62420f0392984d3e2ef2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "The Corner Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "114 S Park Square NE, Marietta, GA 30060, USA",
      "poi_short_description": "Grocery store supplying specialty British products including food and gifts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-6ec7-7699-bba6-9e79e5c9672c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-6ec7-7699-bba6-9e79e5c9672c",
        "storage_key": "property/5745879600332800/019f14f7-6ec7-7699-bba6-9e79e5c9672c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thecornershopga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=842985691752591152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-corner-shop",
      "poi_latitude": "33.952129",
      "poi_longitude": "-84.549503",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-794-8747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bd9c-7099-a2d3-42de2e3ec046.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bd9c-7099-a2d3-42de2e3ec046",
        "storage_key": "property/5745879600332800/019d02f3-bd9c-7099-a2d3-42de2e3ec046.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfxt-iSQU9YgRMG-mMwXjsgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_3272bb1a0f31c72222e90dde",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Chattahoochee Technical College - Marietta Campus",
      "poi_type": "Education",
      "poi_address": "980 S Cobb Dr SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-836f-7502-b1f7-6d7f80173293.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-836f-7502-b1f7-6d7f80173293",
        "storage_key": "property/5745879600332800/019f14f7-836f-7502-b1f7-6d7f80173293.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.chattahoocheetech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13769443296039744384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chattahoochee-technical-college---marietta-campus",
      "poi_latitude": "33.9290773",
      "poi_longitude": "-84.5526426",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 770-528-4545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUc0HKI4W9YgRgDNVX7njFr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_c729e01157dc5e944df104cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Fair Oaks Elementary School",
      "poi_type": "Education",
      "poi_address": "407 Barber Rd, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-7d24-73ba-bcdf-af4f011a9e19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-7d24-73ba-bcdf-af4f011a9e19",
        "storage_key": "property/5745879600332800/019f14f7-7d24-73ba-bcdf-af4f011a9e19.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cobbk12.org/fairoaks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1692753434244037306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fair-oaks-elementary-school",
      "poi_latitude": "33.9176143",
      "poi_longitude": "-84.5474449",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 678-594-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2VjnkcEW9YgRujpwpEfefRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_6f25a827cadb8b101df0a124",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Susan Todd Pearson Middle School",
      "poi_type": "Education",
      "poi_address": "240 Barber Rd, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cobbk12.org/Pearson",
      "poi_directions_map_url": "https://maps.google.com/?cid=2414954957428480695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "susan-todd-pearson-middle-school",
      "poi_latitude": "33.9162643",
      "poi_longitude": "-84.5460528",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 770-429-6012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhRXLDl4X9YgRt9oXIr2kgyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_ad769e14ae44d5dbd5716b63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Osborne High School",
      "poi_type": "Education",
      "poi_address": "2451 Favor Rd SW, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-8e6e-7380-b210-04df9479a6e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-8e6e-7380-b210-04df9479a6e8",
        "storage_key": "property/5745879600332800/019f14f7-8e6e-7380-b210-04df9479a6e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cobbk12.org/osborne/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18025101001726816609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "osborne-high-school",
      "poi_latitude": "33.8945721",
      "poi_longitude": "-84.56522319999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-437-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN6H5t6kX9YgRYfF2KNwFJvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_80085d7313e75ea8c4033b64",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Birney Elementary School",
      "poi_type": "Education",
      "poi_address": "775 Smyrna Powder Springs Rd SW, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-75ca-73c5-a88b-af09f003d83e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-75ca-73c5-a88b-af09f003d83e",
        "storage_key": "property/5745879600332800/019f14f7-75ca-73c5-a88b-af09f003d83e.webp",
        "width": 961,
        "height": 720
      },
      "poi_business_url": "https://www.cobbk12.org/birney",
      "poi_directions_map_url": "https://maps.google.com/?cid=3814410211364114049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "birney-elementary-school",
      "poi_latitude": "33.8793772",
      "poi_longitude": "-84.5761526",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-842-6824",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgRSdrL0X9YgRgQ77q-CB7zQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_de5e5f44636056c1c643c3d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Hollydale Elementary School",
      "poi_type": "Education",
      "poi_address": "2901 Bay Berry Dr SW, Marietta, GA 30008, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-7df5-7123-8204-1e100131568f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-7df5-7123-8204-1e100131568f",
        "storage_key": "property/5745879600332800/019f14f7-7df5-7123-8204-1e100131568f.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://www.cobbk12.org/hollydale/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1844152379102296680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hollydale-elementary-school",
      "poi_latitude": "33.8820755",
      "poi_longitude": "-84.610871",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 678-594-8143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6eGr2WY99YgRaHoVbNG-lxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_dcdfde26cc602fb51fe52ed9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Crescent Lakes Academy Learning Center",
      "poi_type": "Education",
      "poi_address": "1456 S Cobb Dr SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://crescentlakesacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15322047567516232274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crescent-lakes-academy-learning-center",
      "poi_latitude": "33.9171506",
      "poi_longitude": "-84.54919540000002",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 770-426-8065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ289m0zoX9YgRUmpxPRXZotQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_28c833b6f40af553177cf138",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "The Treasure Box Teaching and Learning Center LLC",
      "poi_type": "Education",
      "poi_address": "14 Larose Dr SW, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-94f0-72bf-9f97-790acba88853.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-94f0-72bf-9f97-790acba88853",
        "storage_key": "property/5745879600332800/019f14f7-94f0-72bf-9f97-790acba88853.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thetreasurebox100.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2666945488154094203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-treasure-box-teaching-and-learning-center-llc",
      "poi_latitude": "33.8982313",
      "poi_longitude": "-84.5551389",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-558-5393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpXnAWuUX9YgRe2rBmMrkAiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "ec_2fbb420391bcc566a1994eff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "The Walker School",
      "poi_type": "Education",
      "poi_address": "700 Cobb Pkwy N, Marietta, GA 30062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-82b5-748d-b658-887a0644e6ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-82b5-748d-b658-887a0644e6ec",
        "storage_key": "property/5745879600332800/019f14f7-82b5-748d-b658-887a0644e6ec.webp",
        "width": 1280,
        "height": 756
      },
      "poi_business_url": "http://www.thewalkerschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14176530403720676904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-walker-school",
      "poi_latitude": "33.9714287",
      "poi_longitude": "-84.5358018",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-427-2689",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9aqeZGwU9YgRKMZLrUonvcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_63b79e023a795ec484b8b329",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Marietta Center for Advanced Academics",
      "poi_type": "Education",
      "poi_address": "311 Aviation Rd SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mcaa.marietta-city.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3943652259840215530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marietta-center-for-advanced-academics",
      "poi_latitude": "33.9447014",
      "poi_longitude": "-84.5258747",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-420-0822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1by3jQEU9YgR6klxAdaqujY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_e722a76e173fe0fe3cc71e03",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Earl and Rachel Smith Strand Theatre",
      "poi_type": "Entertainment",
      "poi_address": "117 N Park Square, Marietta, GA 30060, USA",
      "poi_short_description": "Restored art deco theater (ca. 1935) offering classic films, live music & tours of the venue.",
      "poi_long_description": "Restored art deco theater (ca. 1935) offering classic films, live music & tours of the venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-a17f-7789-add9-96acdb11f4c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-a17f-7789-add9-96acdb11f4c4",
        "storage_key": "property/5745879600332800/019f14f7-a17f-7789-add9-96acdb11f4c4.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://earlsmithstrand.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12191965499210838609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earl-and-rachel-smith-strand-theatre",
      "poi_latitude": "33.95361219999999",
      "poi_longitude": "-84.5492054",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-293-0080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQasflyQU9YgRUbJHlgaQMqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_a558da6a04b31f645344269e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Marietta History Center",
      "poi_type": "Entertainment",
      "poi_address": "1 Depot St, Marietta, GA 30060, USA",
      "poi_short_description": "Storied building housing 4 unique galleries preserving local history from home life to the military.",
      "poi_long_description": "Storied building housing 4 unique galleries preserving local history from home life to the military.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-9baf-713f-8651-29ceb4c19c93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-9baf-713f-8651-29ceb4c19c93",
        "storage_key": "property/5745879600332800/019f14f7-9baf-713f-8651-29ceb4c19c93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mariettahistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2571054142064601709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marietta-history-center",
      "poi_latitude": "33.9526204",
      "poi_longitude": "-84.5508732",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-794-5710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c400-7359-a6b3-83f2046f3278.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c400-7359-a6b3-83f2046f3278",
        "storage_key": "property/5745879600332800/019d02f3-c400-7359-a6b3-83f2046f3278.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJpybZ-iQU9YgRbaoOxB44riM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "ec_504c5a0e6563d152bd4ef3ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Marietta Cobb Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "30 Atlanta St SE, Marietta, GA 30060, USA",
      "poi_short_description": "Nonprofit museum with a focus on American art featuring a permanent collection and special exhibitions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-8293-760b-a8e4-f842d3c8a4e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-8293-760b-a8e4-f842d3c8a4e2",
        "storage_key": "property/5745879600332800/019f14f7-8293-760b-a8e4-f842d3c8a4e2.webp",
        "width": 1100,
        "height": 736
      },
      "poi_business_url": "http://www.mariettacobbartmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5432789240734581104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marietta-cobb-museum-of-art",
      "poi_latitude": "33.9513585",
      "poi_longitude": "-84.54932699999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-528-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c400-7359-a6b3-83f2046f3278.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c400-7359-a6b3-83f2046f3278",
        "storage_key": "property/5745879600332800/019d02f3-c400-7359-a6b3-83f2046f3278.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJXTWweiQU9YgRcIGMwQclZUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_032d2b8597fb9a2b900298c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Gone With the Wind Museum at Brumby Hall",
      "poi_type": "Entertainment",
      "poi_address": "472 Powder Springs St SW, Marietta, GA 30064, USA",
      "poi_short_description": "Museum celebrating the Margaret Mitchell novel & film, with costumes, rare prints & memorabilia.",
      "poi_long_description": "Museum celebrating the Margaret Mitchell novel & film, with costumes, rare prints & memorabilia.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f4-cd3f-719e-9104-59e5620e3b45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-cd3f-719e-9104-59e5620e3b45",
        "storage_key": "property/5745879600332800/019f14f4-cd3f-719e-9104-59e5620e3b45.webp",
        "width": 1280,
        "height": 974
      },
      "poi_business_url": "http://www.gwtwmarietta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16631762022833324951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gone-with-the-wind-museum-at-brumby-hall",
      "poi_latitude": "33.9437699",
      "poi_longitude": "-84.5521522",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-794-5576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c400-7359-a6b3-83f2046f3278.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c400-7359-a6b3-83f2046f3278",
        "storage_key": "property/5745879600332800/019d02f3-c400-7359-a6b3-83f2046f3278.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJn7tjAQ4U9YgRlwPQ33Djz-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_0a90e7869ddfd5c667e1f7e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "NCG Cinemas - Marietta",
      "poi_type": "Entertainment",
      "poi_address": "1050 Powder Springs St SW, Marietta, GA 30064, USA",
      "poi_short_description": "Family-owned movie theater chain featuring digital screens for the latest releases.",
      "poi_long_description": "Family-owned movie theater chain featuring digital screens for the latest releases.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-a8b1-705e-afce-f566cd9107a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-a8b1-705e-afce-f566cd9107a8",
        "storage_key": "property/5745879600332800/019f14f7-a8b1-705e-afce-f566cd9107a8.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.ncgmovies.com/movie-theater/marietta",
      "poi_directions_map_url": "https://maps.google.com/?cid=16983353982820148614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ncg-cinemas---marietta",
      "poi_latitude": "33.927595",
      "poi_longitude": "-84.5720621",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-303-4844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-19ce-779b-a135-57d94b6e215a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-19ce-779b-a135-57d94b6e215a",
        "storage_key": "property/5745879600332800/019f14f8-19ce-779b-a135-57d94b6e215a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJiXB2iGYW9YgRhuW1OHf-sOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_934294223b6eb02ca0e31749",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Six Flags White Water",
      "poi_type": "Entertainment",
      "poi_address": "250 Cobb Pkwy N, Marietta, GA 30062, USA",
      "poi_short_description": "Expansive water park boasting slides, a fantasy tree house & attractions for young kids.",
      "poi_long_description": "Expansive water park boasting slides, a fantasy tree house & attractions for young kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f4-c065-75e5-a5ad-3fa48624c952.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-c065-75e5-a5ad-3fa48624c952",
        "storage_key": "property/5745879600332800/019f14f4-c065-75e5-a5ad-3fa48624c952.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/whitewater",
      "poi_directions_map_url": "https://maps.google.com/?cid=11533852058753994014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-flags-white-water",
      "poi_latitude": "33.9577663",
      "poi_longitude": "-84.5209874",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-590-4067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5ya7qAkU9YgRHo3wpVZ5EKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_2fb097f633c8e30d8c97d325",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Kennesaw Mountain National Battlefield Park",
      "poi_type": "Entertainment",
      "poi_address": "900 Kennesaw Mountain Dr, Kennesaw, GA 30152, USA",
      "poi_short_description": "Preserved site of an 1864 Civil War battle, with a visitor's center featuring a film & artifacts.",
      "poi_long_description": "Preserved site of an 1864 Civil War battle, with a visitor's center featuring a film & artifacts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f4-fdb7-76e8-90d6-21da2798c2d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-fdb7-76e8-90d6-21da2798c2d5",
        "storage_key": "property/5745879600332800/019f14f4-fdb7-76e8-90d6-21da2798c2d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nps.gov/kemo/planyourvisit/basicinfo.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=12922400720938949333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kennesaw-mountain-national-battlefield-park",
      "poi_latitude": "33.9513354",
      "poi_longitude": "-84.59639930000002",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-427-4686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c92e-730d-8b24-633445aa7fab",
        "storage_key": "property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbfcDO6QV9YgR1VrRaP2WVbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c349a77e927ecfb48f63c6af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Southern Museum of Civil War and Locomotive History",
      "poi_type": "Entertainment",
      "poi_address": "2829 Cherokee St NW, Kennesaw, GA 30144, USA",
      "poi_short_description": "Smithsonian affiliate with hands-on permanent & traveling exhibits on the Civil War-era railroad.",
      "poi_long_description": "Smithsonian affiliate with hands-on permanent & traveling exhibits on the Civil War-era railroad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-acd6-746c-9910-0d59012a2a7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-acd6-746c-9910-0d59012a2a7a",
        "storage_key": "property/5745879600332800/019f14f7-acd6-746c-9910-0d59012a2a7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.southernmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17523062878978639498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-museum-of-civil-war-and-locomotive-history",
      "poi_latitude": "34.0242119",
      "poi_longitude": "-84.614238",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 770-427-2117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c400-7359-a6b3-83f2046f3278.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c400-7359-a6b3-83f2046f3278",
        "storage_key": "property/5745879600332800/019d02f3-c400-7359-a6b3-83f2046f3278.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJxZ0MK-U_9YgRigZb5thsLvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_95d9e77f6c05d02f9639f1ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Sewell Mill Library & Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "2051 Lower Roswell Rd, Marietta, GA 30068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-b9a1-76c7-8714-77af992a102e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-b9a1-76c7-8714-77af992a102e",
        "storage_key": "property/5745879600332800/019f14f7-b9a1-76c7-8714-77af992a102e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cobbcounty.gov/library/library-locations/sewell-mill-library",
      "poi_directions_map_url": "https://maps.google.com/?cid=10029561306711873122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sewell-mill-library--cultural-center",
      "poi_latitude": "33.9499568",
      "poi_longitude": "-84.4920313",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-509-2711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_5PU99oT9YgRYlaQm94oMIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "ec_23e19efe59b294a64b868517",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Cobb Energy Performing Arts Centre",
      "poi_type": "Entertainment",
      "poi_address": "2800 Cobb Galleria Pkwy, Atlanta, GA 30339, USA",
      "poi_short_description": "Big, modern facility featuring a host of opera performances, ballets, shows, events & more.",
      "poi_long_description": "Big, modern facility featuring a host of opera performances, ballets, shows, events & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-d2cc-749e-938d-c1611fbe96dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-d2cc-749e-938d-c1611fbe96dd",
        "storage_key": "property/5745879600332800/019f14f7-d2cc-749e-938d-c1611fbe96dd.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.cobbenergycentre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3498408923151972920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cobb-energy-performing-arts-centre",
      "poi_latitude": "33.88471",
      "poi_longitude": "-84.4585962",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-916-2852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb-C19jcQ9YgROLqHV2HYjDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_7fa47d6c595a173bccc023de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Wellstar Kennestone Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "677 Church St, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f4-edb7-7585-975b-0fb60c242c29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-edb7-7585-975b-0fb60c242c29",
        "storage_key": "property/5745879600332800/019f14f4-edb7-7585-975b-0fb60c242c29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wellstar.org/locations/hospital/kennestone-regional-medical-center?utm_medium=listing&utm_source=google&utm_content=Wellstar_Kennestone_Regional_Medical_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9445245318065923232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wellstar-kennestone-regional-medical-center",
      "poi_latitude": "33.9689878",
      "poi_longitude": "-84.55210040000001",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-793-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c40d-701d-9bb2-005d27893149.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c40d-701d-9bb2-005d27893149",
        "storage_key": "property/5745879600332800/019d02f3-c40d-701d-9bb2-005d27893149.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQVepTEYU9YgRoKS935JAFIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_9d95ae06ee08a27d56576637",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Piedmont Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "789 Church St Ste 200, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-b491-72cc-96aa-2002cba55765.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-b491-72cc-96aa-2002cba55765",
        "storage_key": "property/5745879600332800/019f14f7-b491-72cc-96aa-2002cba55765.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmonturgentcare.org/locations/marietta-ga?location=122&utm_source=rioseo&utm_medium=local&utm_content=clinic_link_122",
      "poi_directions_map_url": "https://maps.google.com/?cid=11153943370916877501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-urgent-care",
      "poi_latitude": "33.9706306",
      "poi_longitude": "-84.5509335",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-881-7964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV5IQ2ekV9YgRvdRSVGbEypo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_f2792613420e991383cd8725",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "American Family Care Marietta",
      "poi_type": "Health and Wellness",
      "poi_address": "3481 Ernest W Barrett Pkwy SW, Marietta, GA 30064, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-b823-767d-9846-f1d39ffee250.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-b823-767d-9846-f1d39ffee250",
        "storage_key": "property/5745879600332800/019f14f7-b823-767d-9846-f1d39ffee250.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://www.afcurgentcare.com/marietta/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17073062402236878344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-family-care-marietta",
      "poi_latitude": "33.9445701",
      "poi_longitude": "-84.6235368",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 678-621-2178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsVTxZQo-9YgRCA5oQcyz7-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_fb6e728c758c70e96588676f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Sam's Club Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "150 Cobb Pkwy SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-6a69-7345-9bfe-0c7a1836be77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-6a69-7345-9bfe-0c7a1836be77",
        "storage_key": "property/5745879600332800/019f14f7-6a69-7345-9bfe-0c7a1836be77.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/8203-marietta-ga/pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=15099925735343735250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club-pharmacy",
      "poi_latitude": "33.9487791",
      "poi_longitude": "-84.5213495",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-285-0242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-1970-7053-be17-4f9d8aae1c23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-1970-7053-be17-4f9d8aae1c23",
        "storage_key": "property/5745879600332800/019f14f8-1970-7053-be17-4f9d8aae1c23.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsSLguvgT9YgR0kHxFXS2jdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_732c6d95e9d58e99517ce840",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "210 Cobb Pkwy SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-c4a0-72ec-ae04-7f041dfe9b6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-c4a0-72ec-ae04-7f041dfe9b6e",
        "storage_key": "property/5745879600332800/019f14f7-c4a0-72ec-ae04-7f041dfe9b6e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/5390-marietta-ga/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15035156697038802568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "33.946249",
      "poi_longitude": "-84.52155859999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-429-9092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-1970-7053-be17-4f9d8aae1c23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-1970-7053-be17-4f9d8aae1c23",
        "storage_key": "property/5745879600332800/019f14f8-1970-7053-be17-4f9d8aae1c23.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6XB-ZRAR9YgRiE5VNVubp9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_233cb3e14c7903b1a4db04e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "K & Y Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1815 S Cobb Dr SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-5a05-72fa-9cf5-531686654990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-5a05-72fa-9cf5-531686654990",
        "storage_key": "property/5745879600332800/019f14f7-5a05-72fa-9cf5-531686654990.webp",
        "width": 960,
        "height": 536
      },
      "poi_business_url": "http://www.knypharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7726330457095112782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "k--y-pharmacy",
      "poi_latitude": "33.9087541",
      "poi_longitude": "-84.54342319999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-989-1332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-1970-7053-be17-4f9d8aae1c23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-1970-7053-be17-4f9d8aae1c23",
        "storage_key": "property/5745879600332800/019f14f8-1970-7053-be17-4f9d8aae1c23.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Ve3pysX9YgRTohvaJ1wOWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_f2c0b827eb69bfc7cd338d7b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "City of Marietta Custer Park Sports and Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "545 Kenneth E Marcus Way, Marietta, GA 30060, USA",
      "poi_short_description": "Indoor rec center featuring a weight room, plus courts for basketball and pickleball.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-d757-7256-ba11-2cfb523cb49e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-d757-7256-ba11-2cfb523cb49e",
        "storage_key": "property/5745879600332800/019f14f7-d757-7256-ba11-2cfb523cb49e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://secure.rec1.com/GA/city-of-marietta/catalog",
      "poi_directions_map_url": "https://maps.google.com/?cid=11300806410189838680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-marietta-custer-park-sports-and-fitness-center",
      "poi_latitude": "33.963098",
      "poi_longitude": "-84.5356984",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-794-5630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFY_0BxMU9YgRWJnSSo6H1Jw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_d31293395be586340a1523ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 Cobb Pl Ln NW Ste 310, Kennesaw, GA 30144, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f4-e962-77ab-95db-e782fb4f5434.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-e962-77ab-95db-e782fb4f5434",
        "storage_key": "property/5745879600332800/019f14f4-e962-77ab-95db-e782fb4f5434.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/kennesaw-barrett-pkwy-ga?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2214771988271860830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.0133389",
      "poi_longitude": "-84.5728324",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-421-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgyOx-dwV9YgRXgxuk2NzvB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_31f0e2a722bdf48cf5f05741",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Sol Yoga Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "3931 Mary Eliza Trace NW #210, Marietta, GA 30064, USA",
      "poi_short_description": "Studio offering yoga classes, including aerial yoga and infrared-heated sessions, plus workshops.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-cc7f-74ca-ab05-dcae908d3912.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-cc7f-74ca-ab05-dcae908d3912",
        "storage_key": "property/5745879600332800/019f14f7-cc7f-74ca-ab05-dcae908d3912.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://solyogawestcobb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=192538360254128825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sol-yoga-studio",
      "poi_latitude": "33.96666130000001",
      "poi_longitude": "-84.6662781",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 706-816-1127",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-3tL0TM_9YgRuWKVWJ4IrAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_77f8853c93290e0fe815ddd4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3000 Windy Hill Rd SE #156, Marietta, GA 30067, USA",
      "poi_short_description": "Cardio-focused fitness center with classes combining cardio and strength training, alongside personalized experiences.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-df45-73e8-ac47-d1b418cedc19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-df45-73e8-ac47-d1b418cedc19",
        "storage_key": "property/5745879600332800/019f14f7-df45-73e8-ac47-d1b418cedc19.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/marietta-georgia-0374?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=12602914384122703962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "33.9042402",
      "poi_longitude": "-84.4663041",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-701-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhfNP-7AR9YgRWnBL-NuL5q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_c8b00dd21baa43f727ff3851",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "A.L. Burruss Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "75 S Cobb Dr, Marietta, GA 30060, USA",
      "poi_short_description": "This 45-acre park offers hiking & biking trails through the forest, plus picnic areas.",
      "poi_long_description": "This 45-acre park offers hiking & biking trails through the forest, plus picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-ec10-71a0-b6ed-2fed5b210a10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-ec10-71a0-b6ed-2fed5b210a10",
        "storage_key": "property/5745879600332800/019f14f7-ec10-71a0-b6ed-2fed5b210a10.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.mariettaga.gov/facilities/facility/details/AL-Burruss-Nature-Park-7",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013865383943168988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "al-burruss-nature-park",
      "poi_latitude": "33.9231826",
      "poi_longitude": "-84.5084546",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-794-5602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c92e-730d-8b24-633445aa7fab",
        "storage_key": "property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2q7-EYR9YgR3GOPiQDUlEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0397bbce1b892a5c1abe99b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Wildwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Wildwood Park, 1050 Barclay Cir, Marietta, GA 30060, USA",
      "poi_short_description": "This 28-acre space features jogging & hiking trails, a playground & an off-leash dog park.",
      "poi_long_description": "This 28-acre space features jogging & hiking trails, a playground & an off-leash dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-e30a-76af-b580-1845d37ef613.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-e30a-76af-b580-1845d37ef613",
        "storage_key": "property/5745879600332800/019f14f7-e30a-76af-b580-1845d37ef613.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mariettaga.gov/facilities/facility/details/Wildwood-Park-29",
      "poi_directions_map_url": "https://maps.google.com/?cid=8601451077639099271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wildwood-park",
      "poi_latitude": "33.9308788",
      "poi_longitude": "-84.5220583",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-794-5601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c92e-730d-8b24-633445aa7fab",
        "storage_key": "property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC5S96E4R9YgRh1OUwy5-Xnc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_89b9fa1326e550938c073bf3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Kennesaw Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1306 Whitlock Ave NW, Marietta, GA 30064, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-d1bf-7379-ab1e-d0703f030629.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-d1bf-7379-ab1e-d0703f030629",
        "storage_key": "property/5745879600332800/019f14f7-d1bf-7379-ab1e-d0703f030629.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.dignitymemorial.com/funeral-homes/georgia/marietta/kennesaw-memorial-park/6228?utm_source=google_my_business&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15992758598527487101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kennesaw-memorial-park",
      "poi_latitude": "33.9491088",
      "poi_longitude": "-84.5906742",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-428-0502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-19c1-73f6-a842-7cc4d873138b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-19c1-73f6-a842-7cc4d873138b",
        "storage_key": "property/5745879600332800/019f14f8-19c1-73f6-a842-7cc4d873138b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD4gUO-IV9YgRfQzOSzax8d0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cemetery"
    },
    {
      "id": "ec_080743d8076d13d24ac9c1b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Larry Bell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "592 Fairground St SE, Marietta, GA 30060, USA",
      "poi_short_description": "Park featuring tennis courts, a playground and baseball fields, as well as a running track.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-dc83-768d-8d0c-f83229766156.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-dc83-768d-8d0c-f83229766156",
        "storage_key": "property/5745879600332800/019f14f7-dc83-768d-8d0c-f83229766156.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cobbcounty.org/parks/parks-and-nature/locations/larry-bell-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13658899865867754186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "larry-bell-park",
      "poi_latitude": "33.941443",
      "poi_longitude": "-84.53862860000001",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-528-8839",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c92e-730d-8b24-633445aa7fab",
        "storage_key": "property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTVLbyKAW9YgRypqtXw8pjr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2259b2482c723a96e591ce3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Henry Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "81 Reynolds St, Marietta, GA 30064, USA",
      "poi_short_description": "Comfortable neighborhood park featuring playgrounds with slides & grassy picnic grounds.",
      "poi_long_description": "Comfortable neighborhood park featuring playgrounds with slides & grassy picnic grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-ece9-7492-81c8-fb0cde314cc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-ece9-7492-81c8-fb0cde314cc5",
        "storage_key": "property/5745879600332800/019f14f7-ece9-7492-81c8-fb0cde314cc5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mariettaga.gov/Facilities/Facility/Details/Henry-Memorial-Park-17",
      "poi_directions_map_url": "https://maps.google.com/?cid=5775470424514601007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henry-memorial-park",
      "poi_latitude": "33.9467681",
      "poi_longitude": "-84.5548133",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-794-5601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c92e-730d-8b24-633445aa7fab",
        "storage_key": "property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFfyAiigU9YgRL6D3V8CXJlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a187e4432fcd42704d54d2d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Glover Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "50 N Park Square, Marietta, GA 30060, USA",
      "poi_short_description": "Town square for a train-themed playground, fountains and grassy spots.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-e3d9-7389-85ce-3090877e2a44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-e3d9-7389-85ce-3090877e2a44",
        "storage_key": "property/5745879600332800/019f14f7-e3d9-7389-85ce-3090877e2a44.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mariettaga.gov/facilities/facility/details/glover-park-15",
      "poi_directions_map_url": "https://maps.google.com/?cid=2949558028462787250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glover-park",
      "poi_latitude": "33.9528014",
      "poi_longitude": "-84.54960129999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-794-5601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c92e-730d-8b24-633445aa7fab",
        "storage_key": "property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bp36yQU9YgRsgrtQmbv7ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_00a799aeba93aa5b7fbf588e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Brown Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "358 West Atlanta St SE, Marietta, GA 30064, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-ec20-77c3-9699-c1bdc3a81680.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-ec20-77c3-9699-c1bdc3a81680",
        "storage_key": "property/5745879600332800/019f14f7-ec20-77c3-9699-c1bdc3a81680.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mariettaga.gov/Facilities/Facility/Details/Brown-Park-10",
      "poi_directions_map_url": "https://maps.google.com/?cid=17656616123889452274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brown-park",
      "poi_latitude": "33.9470565",
      "poi_longitude": "-84.5492463",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c92e-730d-8b24-633445aa7fab",
        "storage_key": "property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtUSA2yYU9YgR8oTd39DmCPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2e462e1d59fad37840c64986",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Bells Ferry Trailhead at Noonday Creek",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3001 Bells Ferry Rd NE, Marietta, GA 30066, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-f330-7358-8698-64b0601949a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-f330-7358-8698-64b0601949a8",
        "storage_key": "property/5745879600332800/019f14f7-f330-7358-8698-64b0601949a8.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://towncentercid.com/project/bells-ferry-trailhead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7895407762639473105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bells-ferry-trailhead-at-noonday-creek",
      "poi_latitude": "34.0234656",
      "poi_longitude": "-84.54842359999999",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxSnDfRQV9YgR0cn8SIcfkm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_7e176f3b32be42e1e2cdb0e5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Kennesaw Mountain National Battlefield Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 Kennesaw Mountain Dr, Kennesaw, GA 30152, USA",
      "poi_short_description": "Preserved site of an 1864 Civil War battle, with a visitor's center featuring a film & artifacts.",
      "poi_long_description": "Preserved site of an 1864 Civil War battle, with a visitor's center featuring a film & artifacts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f4-fdb7-76e8-90d6-21da2798c2d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-fdb7-76e8-90d6-21da2798c2d5",
        "storage_key": "property/5745879600332800/019f14f4-fdb7-76e8-90d6-21da2798c2d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nps.gov/kemo/planyourvisit/basicinfo.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=12922400720938949333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kennesaw-mountain-national-battlefield-park",
      "poi_latitude": "33.9513354",
      "poi_longitude": "-84.59639930000002",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-427-4686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c92e-730d-8b24-633445aa7fab",
        "storage_key": "property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbfcDO6QV9YgR1VrRaP2WVbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7eaabaf35677af89aa42bf44",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Merritt Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Merritt Park, 501 Wallace Rd, Marietta, GA 30062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17556579517006896387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merritt-park",
      "poi_latitude": "33.9639718",
      "poi_longitude": "-84.515501",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c92e-730d-8b24-633445aa7fab",
        "storage_key": "property/5745879600332800/019d02f3-c92e-730d-8b24-633445aa7fab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____NvMT9YgRA10YTg2ApfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f98c26192abafd63b0f33f77",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Marietta Transfer Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "800 South Marietta Pkwy SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-fa2c-73f1-935e-c39af906610e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-fa2c-73f1-935e-c39af906610e",
        "storage_key": "property/5745879600332800/019f14f7-fa2c-73f1-935e-c39af906610e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cobbcounty.org/cct",
      "poi_directions_map_url": "https://maps.google.com/?cid=6068522176714587193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marietta-transfer-center",
      "poi_latitude": "33.941739",
      "poi_longitude": "-84.5296346",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-427-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-19cf-71f2-9334-526bf1f6ab06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-19cf-71f2-9334-526bf1f6ab06",
        "storage_key": "property/5745879600332800/019f14f8-19cf-71f2-9334-526bf1f6ab06.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZUqyakW9YgROTynbsS4N1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_0dbd4c1bc82805f726849169",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Busbee/Town Center Park & Ride Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "3321 Busbee Dr NW, Kennesaw, GA 30144, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-fce4-773b-b478-d76b19934db2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-fce4-773b-b478-d76b19934db2",
        "storage_key": "property/5745879600332800/019f14f7-fce4-773b-b478-d76b19934db2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10144491077164117624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "busbeetown-center-park--ride-lot",
      "poi_latitude": "34.0290645",
      "poi_longitude": "-84.5700717",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-19ca-77fe-a71a-425a46b36b95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-19ca-77fe-a71a-425a46b36b95",
        "storage_key": "property/5745879600332800/019f14f8-19ca-77fe-a71a-425a46b36b95.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJFX74ESwV9YgReK58CeN4yIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_6ef1fbca4e1268a8e3096c10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Town Center / Big Shanty Park-and-Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Town Center, GA 30144, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-045a-7649-a794-4fe80093ad4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-045a-7649-a794-4fe80093ad4c",
        "storage_key": "property/5745879600332800/019f14f8-045a-7649-a794-4fe80093ad4c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6428974945849086466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-center--big-shanty-park-and-ride",
      "poi_latitude": "34.0264491",
      "poi_longitude": "-84.5713146",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoarCoy4V9YgRApI4raZOOFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_cb4cc91c6cb90f839acd705d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Cumberland Transfer Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Cumberland Blvd SE, Atlanta, GA 30339, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-03f0-77e8-83b0-ba2cd36be62b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-03f0-77e8-83b0-ba2cd36be62b",
        "storage_key": "property/5745879600332800/019f14f8-03f0-77e8-83b0-ba2cd36be62b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17526060503120401811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cumberland-transfer-center",
      "poi_latitude": "33.8781653",
      "poi_longitude": "-84.46993950000001",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_UWos1wQ9YgRk9V-qCsTOfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_050a0f835c3354f241fa6412",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Marietta Auto Services",
      "poi_type": "Transportation & Transit",
      "poi_address": "577 South Marietta Pkwy SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-0356-71bb-b627-16a0dc1985ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-0356-71bb-b627-16a0dc1985ab",
        "storage_key": "property/5745879600332800/019f14f8-0356-71bb-b627-16a0dc1985ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10083551221289751800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marietta-auto-services",
      "poi_latitude": "33.9438296",
      "poi_longitude": "-84.5360688",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcZ7wgR0U9YgR-JRuK2n474s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_repair"
    },
    {
      "id": "ec_c73f162d09026f79d51a6b41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Dixie Tavern",
      "poi_type": "Transportation & Transit",
      "poi_address": "2349 Windy Hill Rd SE Unit 130, Marietta, GA 30067, USA",
      "poi_short_description": "Live music nightly accompanies a po' boy & burger-centric Southern menu at this roadhouse-style bar.",
      "poi_long_description": "Live music nightly accompanies a po' boy & burger-centric Southern menu at this roadhouse-style bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-03f9-701b-9dea-7ce7fdd0c5ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-03f9-701b-9dea-7ce7fdd0c5ad",
        "storage_key": "property/5745879600332800/019f14f8-03f9-701b-9dea-7ce7fdd0c5ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dixietavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17182095511610548823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dixie-tavern",
      "poi_latitude": "33.904332",
      "poi_longitude": "-84.486122",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-690-0090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-195d-74bd-990e-b8cedef628a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-195d-74bd-990e-b8cedef628a1",
        "storage_key": "property/5745879600332800/019f14f8-195d-74bd-990e-b8cedef628a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKS_44QYR9YgRV2JhStUQc-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_6d72a6cf41ea063e4afc8a3a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-fe02-746d-b339-83793840f487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-fe02-746d-b339-83793840f487",
        "storage_key": "property/5745879600332800/019f14f7-fe02-746d-b339-83793840f487.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "26.0 mi",
      "poi_walking_minutes": "9 hours 45 mins",
      "poi_biking_minutes": "2 hours 46 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-1a3c-7367-86d6-b598556d89df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-1a3c-7367-86d6-b598556d89df",
        "storage_key": "property/5745879600332800/019f14f8-1a3c-7367-86d6-b598556d89df.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_13fcebc82f799bdd7b69ee90",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Cobb County International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1723 McCollum Pkwy NW, Kennesaw, GA 30144, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-077d-76bc-9025-f7d98fc14b01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-077d-76bc-9025-f7d98fc14b01",
        "storage_key": "property/5745879600332800/019f14f8-077d-76bc-9025-f7d98fc14b01.webp",
        "width": 1100,
        "height": 600
      },
      "poi_business_url": "https://www.cobbcounty.org/transportation/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=11164888349103370715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cobb-county-international-airport",
      "poi_latitude": "34.014574",
      "poi_longitude": "-84.60030139999999",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 770-528-1615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-1a3c-7367-86d6-b598556d89df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-1a3c-7367-86d6-b598556d89df",
        "storage_key": "property/5745879600332800/019f14f8-1a3c-7367-86d6-b598556d89df.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YBOJFwV9YgR2zE0pcym8Zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_416c0a3c18b87776ed8ea29a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Lockheed Martin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "86 S Cobb Dr SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-0a1e-71aa-82f6-e150992c9516.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-0a1e-71aa-82f6-e150992c9516",
        "storage_key": "property/5745879600332800/019f14f8-0a1e-71aa-82f6-e150992c9516.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lockheedmartin.com/us.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7424688263730970538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockheed-martin",
      "poi_latitude": "33.9326147",
      "poi_longitude": "-84.5343963",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-494-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4ZYhz6UW9YgRqj-yX6PKCWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_e740691d29827638ec9f9500",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Chattahoochee Technical College - Marietta Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "980 S Cobb Dr SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f7-836f-7502-b1f7-6d7f80173293.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-836f-7502-b1f7-6d7f80173293",
        "storage_key": "property/5745879600332800/019f14f7-836f-7502-b1f7-6d7f80173293.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.chattahoocheetech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13769443296039744384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chattahoochee-technical-college---marietta-campus",
      "poi_latitude": "33.9290773",
      "poi_longitude": "-84.5526426",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 770-528-4545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUc0HKI4W9YgRgDNVX7njFr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_ea04645ab89d1d476a69c379",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Kennesaw State University Marietta Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1100 South Marietta Pkwy SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-78d2-7129-8ad7-3028ef2be24d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f3-78d2-7129-8ad7-3028ef2be24d",
        "storage_key": "property/5745879600332800/019d02f3-78d2-7129-8ad7-3028ef2be24d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.kennesaw.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9353544289796946844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kennesaw-state-university-marietta-campus",
      "poi_latitude": "33.938376",
      "poi_longitude": "-84.5184443",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 470-578-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJyAxEFUR9YgRnPs6cPl2zoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_fb2cbac462acc80c944fe36b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Wellstar Kennestone Regional Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "677 Church St, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f4-edb7-7585-975b-0fb60c242c29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f4-edb7-7585-975b-0fb60c242c29",
        "storage_key": "property/5745879600332800/019f14f4-edb7-7585-975b-0fb60c242c29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wellstar.org/locations/hospital/kennestone-regional-medical-center?utm_medium=listing&utm_source=google&utm_content=Wellstar_Kennestone_Regional_Medical_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9445245318065923232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wellstar-kennestone-regional-medical-center",
      "poi_latitude": "33.9689878",
      "poi_longitude": "-84.55210040000001",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-793-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c40d-701d-9bb2-005d27893149.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c40d-701d-9bb2-005d27893149",
        "storage_key": "property/5745879600332800/019d02f3-c40d-701d-9bb2-005d27893149.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQVepTEYU9YgRoKS935JAFIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_0bd3ece13b4280849b314285",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Cobb County Government",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Cherokee St NE, Marietta, GA 30090, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-0915-73bd-8898-3321be3a53e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-0915-73bd-8898-3321be3a53e6",
        "storage_key": "property/5745879600332800/019f14f8-0915-73bd-8898-3321be3a53e6.webp",
        "width": 750,
        "height": 422
      },
      "poi_business_url": "http://www.cobbcounty.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11371487866777379842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cobb-county-government",
      "poi_latitude": "33.9536348",
      "poi_longitude": "-84.5487706",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-528-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-1c56-71ae-a874-36060ebeedc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-1c56-71ae-a874-36060ebeedc8",
        "storage_key": "property/5745879600332800/019f14f8-1c56-71ae-a874-36060ebeedc8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93BZoiQU9YgRAiTuUvejz50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "ec_2268724bcfbc038c5646446b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Cobb County School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "514 Glover St SE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-0e12-76c9-b8e4-ae4f346097c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-0e12-76c9-b8e4-ae4f346097c2",
        "storage_key": "property/5745879600332800/019f14f8-0e12-76c9-b8e4-ae4f346097c2.webp",
        "width": 1110,
        "height": 624
      },
      "poi_business_url": "https://www.cobbk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13438620587419201594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cobb-county-school-district",
      "poi_latitude": "33.9384092",
      "poi_longitude": "-84.5380589",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-426-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-bda0-722a-8c2c-9c4319738f86",
        "storage_key": "property/5745879600332800/019d02f3-bda0-722a-8c2c-9c4319738f86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd6cEuaYW9YgROnBfMDmSf7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_21cec72ec3d102d8da0187da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Marietta City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "205 Lawrence St NE, Marietta, GA 30060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-0e23-726d-a658-0bfa30e60eac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-0e23-726d-a658-0bfa30e60eac",
        "storage_key": "property/5745879600332800/019f14f8-0e23-726d-a658-0bfa30e60eac.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "http://www.mariettaga.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=75834314535815323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marietta-city-hall",
      "poi_latitude": "33.9535602",
      "poi_longitude": "-84.5465564",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-794-5530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-1c56-71ae-a874-36060ebeedc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f8-1c56-71ae-a874-36060ebeedc8",
        "storage_key": "property/5745879600332800/019f14f8-1c56-71ae-a874-36060ebeedc8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5zvGFSMU9YgRm0ixQ-hqDQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_1d241213dad3a322bcddc717",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Dobbins Air Reserve Base",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Dobbins Air Reserve Base, GA 30069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14f8-0e78-7770-a0eb-afbf152bbf71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-0e78-7770-a0eb-afbf152bbf71",
        "storage_key": "property/5745879600332800/019f14f8-0e78-7770-a0eb-afbf152bbf71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12739268096597187510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dobbins-air-reserve-base",
      "poi_latitude": "33.9196507",
      "poi_longitude": "-84.5032258",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyRDR0DYR9YgRtlsknNb4yrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_79c11e3e59a44f35703458fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "WellStar Health System Headquarters & Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "805 Sandy Plains Rd, Marietta, GA 30066, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9875052561272446013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wellstar-health-system-headquarters--corporate-office",
      "poi_latitude": "33.99709440000001",
      "poi_longitude": "-84.5267106",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqzeqWwAV9YgRPZz09Ps7C4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_8b529e8dbbf67a7651f23cb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "generator",
      "poi_name": "Emory Heart & Vascular at East Cobb",
      "poi_type": "Major Employers & Offices",
      "poi_address": "137 Johnson Ferry Rd Ste 1200, Marietta, GA 30068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.emoryhealthcare.org/locations/heart-vascular/emory-at-east-cobb?&utm_campaign=hv_all_ra_gmb-locations&utm_source=google&utm_medium=gmb&utm_content=gmb_locations?&utm_campaign=brand_all_non&utm_source=google&utm_medium=gmb&utm_content=gmb-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=4727573426831210396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-heart--vascular-at-east-cobb",
      "poi_latitude": "33.9517421",
      "poi_longitude": "-84.41210799999999",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 404-251-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-c334-7110-b9a8-5258eb08971f",
        "storage_key": "property/5745879600332800/019d02f3-c334-7110-b9a8-5258eb08971f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62x0gsQN9YgRnLfZ4_u2m0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    }
  ],
  "office_hours": [
    {
      "id": "ec_06b770469ee6ad1e29dbe022",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ba0a780df79f51a38893a183",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7f69016a99ae3ff6fa9aabb4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9fb0719180abe4b7c43e3e49",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_64f35194100e8143e62900ec",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_30e47dba78412527228607bf",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_86028b889cee5ff720e489a3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "rating": "5",
      "name": "anne-marie strong",
      "text": "As a resident of over 25 years here. My family and I have been through a lot of management Maintenance and ground keepers.\n\nJessi, Deysi & (Briohny who is an intern). Are always professional, helpful, prompt, and understanding anytime I have anything I need to have addressed. They are the absolute BEST management team we have had in my 25+ years of residence here.\n\nI am truly appreciative of the management team we have here. I would give them a 10 star review if possible!!!\n\nMaintenance……..\n\nBefore the Bentley at Marietta took over. Our maintenance was absolutely unqualified, untrustworthy, obnoxious, foul mouth, maintenance individuals.\n\nThe Bentley at Marietta has employed some exceptionally professional, qualified, experienced, trustworthy, prompt and friendly maintenance crew.\n\nAnytime that I have needed a work order to be completed it has always been done promptly and efficiently.\n\nThe maintenance team Mr. Dave and Mr. Gene are always the last ones to leave at the end of the day. They answer all of your questions and are very helpful. They lend a helping hand when needed.\nI would give them a 10 star review if I could.\n\nI would also like to give our groundskeeper Mel a 10 star review also. She takes pride in the community!!!  The upkeep of the community is impeccable. She is hard-working come rain, shine even snow. Making sure it’s clean and safe, especially for our children who play in this community. She makes sure that the community pet area is clean and safe for ALL of our fur babies. She is an ESSENTIAL part of the entire team!!!\n\nThank You,\nAMS",
      "date": "2026-03-19",
      "title": "false"
    },
    {
      "id": "ec_2cf37342cf6985ec9cafd7b9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "rating": "5",
      "name": "GoddessJenn",
      "text": "Pro: The staff and management in the Cleaning crew are very friendly and they maintain the environment. The Lake view is beautiful attached with the fountain in the center of the lake. Additionally, I like the wildlife like the fish, the turtles and the beautiful ducks.\nCon: The residence the/tenants they don’t respect the environment. There’s trash and littering. I believe the tennis should have some common decency and respect their environment because we are paying for it.",
      "date": "2025-09-08",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_7fcc1298-a439-44e7-aabe-204977fc5d20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f4-061c-75ff-bd1e-7a9b51cc36e9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room with a blue sofa, coffee table, and accent chairs.",
        "public_id": "019d02f4-061c-75ff-bd1e-7a9b51cc36e9",
        "storage_key": "property/5745879600332800/019d02f4-061c-75ff-bd1e-7a9b51cc36e9.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2BR, 2BA - 1,200SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4tpabLMod1u"
    },
    {
      "id": "custom_93a5dec3-88f2-411f-802e-5fb2b083565f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f4-084a-7229-9dc4-e151f3e552e2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen and living area of an apartment, featuring stainless steel appliances and wood-style flooring.",
        "public_id": "019d02f4-084a-7229-9dc4-e151f3e552e2",
        "storage_key": "property/5745879600332800/019d02f4-084a-7229-9dc4-e151f3e552e2.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2BR, 1BA - 1,100SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZNfCZpmESvb"
    },
    {
      "id": "custom_fae45140-8570-4458-b6bb-becf9bc7c726",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f4-12ec-76f3-bbf6-8af4d934abcc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen and living area in an apartment",
        "public_id": "019d02f4-12ec-76f3-bbf6-8af4d934abcc",
        "storage_key": "property/5745879600332800/019d02f4-12ec-76f3-bbf6-8af4d934abcc.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "1BR, 1BA - 800SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7ZTjCfXd1yc"
    },
    {
      "id": "custom_81a9f705-5c8c-4bb1-8229-c27d072e3348",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f14c3-45ad-7339-844c-83744f739346.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-45ad-7339-844c-83744f739346",
        "storage_key": "property/5745879600332800/019f14c3-45ad-7339-844c-83744f739346.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Bentley at Marietta",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/x8PNQOLkc7Y"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-169d-74fe-9d27-a66ece2ae92a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-bentley-at-marietta",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800"
    },
    {
      "lead_collector_id": "0198aa46-1701-71da-b990-a79e12c826ed",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-bentley-at-marietta",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800"
    },
    {
      "lead_collector_id": "0198aa46-1766-77de-abcf-3fa047f8c8ce",
      "lead_source": "LANDING_PAGE",
      "name": "the-bentley-at-marietta",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-marietta-ga-528",
      "search_query": "luxury apartments with pool in Marietta GA",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Marietta, GA",
      "h2_subtitle": "Discover our luxury apartments in Marietta, GA featuring a refreshing swimming pool. Experience modern living with exclusive amenities today.",
      "page_copy": "Experience elevated living at The Bentley at Marietta, where our luxury apartments offer an outstanding lifestyle in the heart of Marietta, GA. Our residents enjoy a stunning swimming pool, perfect for relaxing or socializing, while surrounded by serene lake views. Dive into a lifestyle filled with convenience and luxury at The Bentley.\n\nAt The Bentley at Marietta, you'll find stylish one and two-bedroom floor plans that cater to discerning tastes. Beyond our luxurious pool, enjoy amenities such as a state-of-the-art fitness center, a dog park, and LUXER package lockers. Nestled in Fair Oaks, this community offers both tranquility and convenience, making it the ideal choice for those seeking luxury apartments with pool in Marietta, GA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
      "featured_image_media": {
        "alt_text": "Living room with a teal sectional sofa, coffee table, and ottomans, leading to a kitchen and laundry area.",
        "public_id": "019f6c12-2071-7148-bea6-a96dbdcbaa11",
        "storage_key": "property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Marietta, GA",
      "seo_description": "Discover luxury apartments with pool in Marietta, GA at The Bentley, featuring modern amenities and stunning views.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-near-fair-oaks-406",
      "search_query": "fitness center apartments near Fair Oaks",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near Fair Oaks",
      "h2_subtitle": "Explore apartments near Fair Oaks with a fitness center. Enjoy top amenities and modern living at The Bentley in Marietta.",
      "page_copy": "Nestled in the vibrant Fair Oaks neighborhood, The Bentley at Marietta offers apartments that are perfect for fitness enthusiasts. Our state-of-the-art fitness center is just one of the many stellar amenities available to our residents. Enjoy the convenience of working out right at home in our community, which is designed with your wellness in mind.\n\nAt The Bentley, it's not just about fitness—our modern living spaces come with a suite of amenities like a dog park, swimming pool, and elegant dining rooms. Located near Fair Oaks, our stylish one and two-bedroom floor plans offer the comfort and convenience you need. Discover an active lifestyle and more at The Bentley at Marietta, where apartments with a fitness center are closer than ever.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
      "featured_image_media": {
        "alt_text": "Living room with a teal sectional sofa, coffee table, and ottomans, leading to a kitchen and laundry area.",
        "public_id": "019f6c12-2071-7148-bea6-a96dbdcbaa11",
        "storage_key": "property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near Fair Oaks",
      "seo_description": "Discover fitness center apartments near Fair Oaks at The Bentley in Marietta, offering top amenities and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-dog-park-cobb-county-802",
      "search_query": "pet-friendly apartments with dog park Cobb County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Explore pet-friendly apartments in Cobb County with a dog park. Enjoy welcoming spaces for you and your furry friends at The Bentley at Marietta.",
      "page_copy": "Welcome to The Bentley at Marietta, where pets are family too. Our pet-friendly apartments in Cobb County offer a delightful living experience for you and your four-legged companions. Located in the serene Fair Oaks area, our community features a dedicated dog park, perfect for letting your pet exercise and socialize in a safe environment.\n\nAt The Bentley, we provide more than just a dog park. Our residents enjoy a range of amenities, including a fitness center, swimming pool, and modern package lockers. Our one and two-bedroom floor plans are designed with both style and comfort in mind, giving you and your pet the perfect home. Embrace lively and pet-friendly living in Cobb County at The Bentley.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
      "featured_image_media": {
        "alt_text": "Living room with a teal sectional sofa, coffee table, and ottomans, leading to a kitchen and laundry area.",
        "public_id": "019f6c12-2071-7148-bea6-a96dbdcbaa11",
        "storage_key": "property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park",
      "seo_description": "Discover pet-friendly apartments in Cobb County with a dog park at The Bentley, offering welcoming spaces for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "page_item_url": "apartments-washer-dryer-hookup-marietta-30060-547",
      "search_query": "apartments with washer dryer hookup Marietta 30060",
      "category": "Amenity",
      "h1_title": "Apartments with Washer Dryer Hookup Marietta",
      "h2_subtitle": "Find Marietta apartments with washer dryer hookup in the 30060 area. Modern living at The Bentley includes convenience at your fingertips.",
      "page_copy": "At The Bentley at Marietta, enjoy the convenience of apartments with washer dryer hookups in the bustling area of Marietta, GA 30060. Our community caters to those seeking modern, comfortable living with features that simplify your lifestyle. Experience the ease of in-home laundry capabilities, allowing you more time to enjoy our amazing amenities.\n\nSituated in the Fair Oaks neighborhood, The Bentley offers more than just in-home conveniences. Relax by the swimming pool, work out in our well-equipped fitness center, or spend quality time with your pet at our dog park. Our one and two-bedroom floor plans are designed to enhance your living experience, making The Bentley your ideal choice for apartments in Marietta with these essential features.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
      "featured_image_media": {
        "alt_text": "Living room with a teal sectional sofa, coffee table, and ottomans, leading to a kitchen and laundry area.",
        "public_id": "019f6c12-2071-7148-bea6-a96dbdcbaa11",
        "storage_key": "property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Washer Dryer Hookup Marietta",
      "seo_description": "Discover apartments with washer dryer hookup in Marietta, GA 30060 at The Bentley. Enjoy modern living with essential conveniences today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "page_item_url": "modern-apartments-air-conditioning-cobb-county-990",
      "search_query": "modern apartments with air conditioning in Cobb County",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Air Conditioning",
      "h2_subtitle": "Explore Cobb County's modern apartments with air conditioning. Enjoy comfort and style at The Bentley at Marietta.",
      "page_copy": "Experience the ultimate in comfort with modern apartments featuring air conditioning at The Bentley at Marietta, located in Cobb County. Our contemporary one and two-bedroom floor plans are designed to offer a cool, serene living environment, allowing you to relax and enjoy every moment at home.\n\nBeyond air conditioning, The Bentley provides a wide array of luxurious amenities including a sundeck, fitness center, and scenic views. Situated in the charming Fair Oaks neighborhood, our community offers a perfect blend of convenience and style. Designed with your comfort in mind, The Bentley invites you to enjoy the best in modern living in Cobb County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
      "featured_image_media": {
        "alt_text": "Living room with a teal sectional sofa, coffee table, and ottomans, leading to a kitchen and laundry area.",
        "public_id": "019f6c12-2071-7148-bea6-a96dbdcbaa11",
        "storage_key": "property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Air Conditioning",
      "seo_description": "Discover modern apartments with air conditioning in Cobb County at The Bentley. Experience comfort and style in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-marietta-ga-903",
      "search_query": "one bedroom apartments marietta ga",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Marietta, GA",
      "h2_subtitle": "Discover spacious one bedroom apartments in Marietta, GA. The Bentley at Marietta offers style and comfort in every home.",
      "page_copy": "Live comfortably in our one bedroom apartments in Marietta, GA at The Bentley at Marietta. Perfectly designed for individuals or couples, our spacious floor plans offer modern features that cater to your lifestyle. Each unit boasts thoughtful layouts, ensuring ample living space, and is complemented by stylish finishes that create a welcoming atmosphere.\n\nLocated in the vibrant Fair Oaks area, our community provides easy access to a range of amenities. Enjoy a swim in our pool, work out in our fitness center, or simply relax in the beautiful surroundings. With the added convenience of online services and package lockers, living at The Bentley is both practical and enjoyable. Discover your perfect one bedroom apartment in Marietta today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
      "featured_image_media": {
        "alt_text": "Living room with a teal sectional sofa, coffee table, and ottomans, leading to a kitchen and laundry area.",
        "public_id": "019f6c12-2071-7148-bea6-a96dbdcbaa11",
        "storage_key": "property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Marietta, GA",
      "seo_description": "Explore one bedroom apartments in Marietta, GA at The Bentley. Experience stylish living with modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745879600332800",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-cobb-county-543",
      "search_query": "two bedroom apartments cobb county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Cobb County",
      "h2_subtitle": "Find spacious two bedroom apartments in Cobb County at The Bentley. Discover modern living environments that suit your lifestyle.",
      "page_copy": "Welcome to The Bentley at Marietta, where you'll find spacious two bedroom apartments nestled in the heart of Cobb County. Perfect for families, roommates, or anyone in need of extra space, these apartments offer a harmonious blend of style and functionality. Enjoy open floor plans and contemporary finishes that meet all your living needs.\n\nLocated in the picturesque Fair Oaks neighborhood, our community provides more than just a place to live. It’s a lifestyle. Take advantage of our excellent amenities, including a relaxing pool, sundeck, and a fully-equipped fitness center. Experience convenient living with easy access to local dining, shopping, and entertainment options, making The Bentley the ideal choice for two bedroom apartments in Cobb County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
      "featured_image_media": {
        "alt_text": "Living room with a teal sectional sofa, coffee table, and ottomans, leading to a kitchen and laundry area.",
        "public_id": "019f6c12-2071-7148-bea6-a96dbdcbaa11",
        "storage_key": "property/5745879600332800/019f6c12-2071-7148-bea6-a96dbdcbaa11.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Cobb County",
      "seo_description": "Explore spacious two bedroom apartments in Cobb County at The Bentley. Ideal for comfortable and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2199"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470973"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a50\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a50\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4665838"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M9VS5W7"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443923514"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f8d2e611f13cc2f6"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yjp2kr2zpxl"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/7156ced1-942b-48c7-a65f-dad18f73d83f"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "470-616-7062"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Inpyb2VWU2Y1dk9QSG1YZGREWWh5Nnc9PSIsInZhbHVlIjoiV2pseWRDOWJ2SDhEdEUxbkwxdndoUT09IiwibWFjIjoiNjNkZjUxZmU0OWNiNWVhYmNjNDI4OTNhNGUxNjUwNzFkODFkOWY5ZDdlZTYwNDYyMTI0ODFmNWJjOWYyZjM5NiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2199",
  "custom_repli_id": "2376470973",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a50\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a50\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4665838",
  "custom_google_gtm_id": "GTM-M9VS5W7",
  "custom_rollout_phase": "3",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443923514",
  "custom_knock_community_id": "f8d2e611f13cc2f6",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/yjp2kr2zpxl",
  "custom_self_guided_tour_url": "https://selftournow.com/property/7156ced1-942b-48c7-a65f-dad18f73d83f",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "470-616-7062",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Inpyb2VWU2Y1dk9QSG1YZGREWWh5Nnc9PSIsInZhbHVlIjoiV2pseWRDOWJ2SDhEdEUxbkwxdndoUT09IiwibWFjIjoiNjNkZjUxZmU0OWNiNWVhYmNjNDI4OTNhNGUxNjUwNzFkODFkOWY5ZDdlZTYwNDYyMTI0ODFmNWJjOWYyZjM5NiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "ea890c25-0027-4208-870e-a92494e46a97",
  "custom_audioeye_site_hash": "7efdf1a333e49b238c59fa982dcecbce"
};

export const generatedAt = '2026-11-03T20:31:03.375Z';
